/* TaPanda - logika karty produktu (gift wrap, drugi produkt -30%, kroki personalizacji, zoom, popupy).
   Wyniesione 2026-07-09 z inline <script> snippets/tapanda-main-product-script.liquid (192 KB w HTML
   kazdego PDP, audyt P1) do cache-owalnego assetu. Dane per-produkt/sekcja: window.tapandaMainProductCfg. */
var TPMP = window.tapandaMainProductCfg || {};
TPMP.giftWrap = TPMP.giftWrap || {};

  (function() {
    window.tapandaCatalogPath = window.tapandaCatalogPath || TPMP.catalogPath;
    window.tapandaSecondProductPath = window.tapandaSecondProductPath || TPMP.productUrl;
    window.tapandaSecondProductDiscountCode = window.tapandaSecondProductDiscountCode || TPMP.secondProductDiscountCode;
    window.tapandaGiftWrapOffer = window.tapandaGiftWrapOffer || {
      variantId: TPMP.giftWrap.variantId,
      title: TPMP.giftWrap.title,
      price: TPMP.giftWrap.price,
      description: TPMP.giftWrap.description,
      image: TPMP.giftWrap.image,
      url: TPMP.giftWrap.url
    };

    function initZoomPlugins() {
      var $ = window.jQuery;
      if (!$ || !$.fn) return false;

      if (TPMP.zoomMode === "zoom") {
        if (typeof $.fn.zoom === 'function') {
          $('.zoom').zoom(2);
        }
      }

      if (TPMP.zoomMode === "outer") {
        if (typeof $.fn.ezPlus === 'function') {
          $('.dt-zoom-trigger').ezPlus();
        }
      } else if (TPMP.zoomMode === "cloud") {
        if (typeof $.fn.ezPlus === 'function') {
          $('.zoom_out').ezPlus({
            zoomType: 'lens',
            lensShape: 'round',
            lensSize: 200
          });
        }
      }

      return true;
    }

    function initNotifyToggle() {
      document.addEventListener('click', function(event) {
        var trigger = event.target.closest('#notify-me');
        if (!trigger) return;
        event.preventDefault();
        var wrapper = document.getElementById('notify-me-wrapper');
        if (!wrapper) return;
        var isHidden = window.getComputedStyle(wrapper).display === 'none';
        wrapper.style.display = isHidden ? 'block' : 'none';
      });
    }

      function getTeeFormNodes(rootNode) {
        if (!rootNode) return [];
        var directCustomizeForms = [];

      if (rootNode.matches && rootNode.matches('.tee-customize-main-form')) {
        directCustomizeForms.push(rootNode);
      }

      if (rootNode.querySelectorAll) {
        Array.from(rootNode.querySelectorAll('.tee-customize-main-form')).forEach(function(formNode) {
          if (directCustomizeForms.indexOf(formNode) === -1) {
            directCustomizeForms.push(formNode);
          }
        });
      }

      if (directCustomizeForms.length) {
        return directCustomizeForms;
      }

      var wrapperForms = [];
      if (rootNode.matches && rootNode.matches('form.tee-form-wrapper')) {
        wrapperForms.push(rootNode);
      }

      if (rootNode.querySelectorAll) {
        Array.from(rootNode.querySelectorAll('form.tee-form-wrapper')).forEach(function(formNode) {
          if (wrapperForms.indexOf(formNode) === -1) {
            wrapperForms.push(formNode);
          }
        });
      }

      if (wrapperForms.length) {
        return wrapperForms;
      }

      var atcForms = [];
      if (rootNode.matches && rootNode.matches('form') && rootNode.querySelector('#teeAtcButton, .tee-btn--atc, #teeFormActions button[type="submit"], .tee-form-actions button[type="submit"]')) {
        atcForms.push(rootNode);
      }

      if (rootNode.querySelectorAll) {
        Array.from(rootNode.querySelectorAll('#teeAtcButton, .tee-btn--atc, #teeFormActions button[type="submit"], .tee-form-actions button[type="submit"]')).forEach(function(buttonNode) {
          var parentForm = buttonNode.closest ? buttonNode.closest('form') : null;
          if (parentForm && atcForms.indexOf(parentForm) === -1) {
            atcForms.push(parentForm);
          }
        });
      }

      return atcForms;
    }

    function getTeeFormNode(node) {
      if (!node || !node.closest) return null;
      var scopedForm = node.closest('.tee-customize-main-form') || node.closest('form.tee-form-wrapper');
      if (scopedForm) return scopedForm;

      var fallbackForm = node.closest('form');
      if (
        fallbackForm &&
        fallbackForm.querySelector &&
        fallbackForm.querySelector('#teeAtcButton, .tee-btn--atc, #teeFormActions button[type="submit"], .tee-form-actions button[type="submit"]')
      ) {
        return fallbackForm;
      }

      return null;
    }

    function trimCreatorTextFields(scopeNode) {
      if (typeof window.tapandaTrimCreatorTextFields !== 'function') return 0;
      return window.tapandaTrimCreatorTextFields(scopeNode);
    }

    var TEE_MUTATION_SCOPE = '#teeinblue-wrapper, [id^="tee"], [class^="tee-"], [class*=" tee-"]';

    function isTeeinblueMutationNode(node) {
      if (!node || node.nodeType !== 1) return false;
      if (node.matches && node.matches(TEE_MUTATION_SCOPE)) return true;
      if (node.closest && node.closest(TEE_MUTATION_SCOPE)) return true;
      return !!(node.querySelector && node.querySelector(TEE_MUTATION_SCOPE));
    }

    function mutationBatchTouchesTeeinblue(records) {
      return records.some(function(record) {
        if (isTeeinblueMutationNode(record.target)) return true;
        return Array.prototype.some.call(record.addedNodes || [], isTeeinblueMutationNode) ||
          Array.prototype.some.call(record.removedNodes || [], isTeeinblueMutationNode);
      });
    }

    function initTeeinblueVariantBridge() {
      var sectionRoot = document.getElementById('MainProduct-' + TPMP.sectionId);
      if (!sectionRoot || sectionRoot.dataset.tibVariantBridgeInit === '1') return;
      sectionRoot.dataset.tibVariantBridgeInit = '1';
      var mutationFrame = null;
      var mutationTimeout = null;

      function isVariantBlock(node) {
        return !!(
          node &&
          node.nodeType === 1 &&
          node.matches &&
          (node.matches('.tee-block.tee-variants') || node.matches('.tee-variants'))
        );
      }

      function getFormDestination(formNode) {
        return (
          formNode.querySelector('#teeFormInputs') ||
          formNode.querySelector('.tee-form-inputs') ||
          formNode.querySelector('.tee-customization-form') ||
          formNode
        );
      }

      function normalizeTeeinblueOptionTitles(rootNode) {
        if (!rootNode) return;
        var optionTitles = rootNode.querySelectorAll('.tee-variants .tee-option__title');
        optionTitles.forEach(function(titleNode) {
          var rawTitle = (titleNode.textContent || '').replace(/[:]/g, '').trim();
          if (!rawTitle) return;
          var normalizedTitle = rawTitle.toLowerCase();
          if (normalizedTitle.indexOf('kolor') === 0) {
            if (titleNode.textContent !== 'Kolor ramki') {
              titleNode.textContent = 'Kolor ramki';
            }
            return;
          }
          if (normalizedTitle.indexOf('rozmiar') === 0) {
            if (titleNode.textContent !== 'Rozmiar obrazu') {
              titleNode.textContent = 'Rozmiar obrazu';
            }
          }
        });

        var sizeLabels = rootNode.querySelectorAll('.tee-option--size .tee-radio-label');
        sizeLabels.forEach(function(labelNode) {
          var valueNode = labelNode.querySelector('span');
          var rawSize = (
            (valueNode ? valueNode.textContent : '') ||
            labelNode.getAttribute('data-title') ||
            labelNode.getAttribute('title') ||
            labelNode.textContent ||
            ''
          )
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();

          var mappedLabel = '';
          var mappedFormat = '';
          if (rawSize.indexOf('a4') === 0) {
            mappedLabel = 'A4 - 20 x 30 cm';
            mappedFormat = 'A4';
          } else if (rawSize.indexOf('a3') === 0) {
            mappedLabel = 'A3 - 30 x 40 cm';
            mappedFormat = 'A3';
          }

          if (!mappedLabel) return;
          var mappedHtml = mappedFormat
            ? '<strong class="tp-size-prefix">' + mappedFormat + '</strong>' + mappedLabel.slice(mappedFormat.length)
            : mappedLabel;

          if (valueNode) {
            if (valueNode.innerHTML !== mappedHtml) {
              valueNode.innerHTML = mappedHtml;
            }
          } else if (labelNode.textContent !== mappedLabel) {
            labelNode.textContent = mappedLabel;
          }
        });
      }

      function getTeeinblueSwatchFillByName(swatchName, fallbackFill) {
        if (!swatchName) return fallbackFill;
        if (swatchName.indexOf('zlot') !== -1 || swatchName.indexOf('gold') !== -1) {
          return 'linear-gradient(145deg, #9a8043 0%, #c2a767 40%, #efe0af 64%, #b49250 100%)';
        }
        if (swatchName.indexOf('srebr') !== -1 || swatchName.indexOf('silver') !== -1) {
          return 'linear-gradient(145deg, #9ea5b0 0%, #c8ced6 40%, #f5f7fa 64%, #aeb5c0 100%)';
        }
        if (swatchName.indexOf('bia') !== -1 || swatchName.indexOf('white') !== -1) {
          return 'linear-gradient(145deg, #ffffff 0%, #f7f5ef 58%, #e8e2d7 100%)';
        }
        if (swatchName.indexOf('czar') !== -1 || swatchName.indexOf('black') !== -1) {
          return 'linear-gradient(145deg, #171920 0%, #2e3138 48%, #0d0f14 100%)';
        }
        return fallbackFill;
      }

      function syncTeeinblueColorSwatches(rootNode) {
        if (!rootNode) return;
        var colorLabels = rootNode.querySelectorAll('.tee-option--color .tee-radio-label');
        colorLabels.forEach(function(labelNode) {
          var swatchNode = labelNode.querySelector('.tee-swatch--color');
          if (!swatchNode) return;
          var fillColor = swatchNode.style && swatchNode.style.backgroundColor ? swatchNode.style.backgroundColor : '';
          if (!fillColor && window.getComputedStyle) {
            fillColor = window.getComputedStyle(swatchNode).backgroundColor;
          }
          var swatchName = (labelNode.getAttribute('title') || labelNode.getAttribute('data-title') || '').toLowerCase();
          if (!fillColor || fillColor === 'transparent' || fillColor === 'rgba(0, 0, 0, 0)') {
            fillColor = '#ffffff';
          }
          fillColor = getTeeinblueSwatchFillByName(swatchName, fillColor);
          if (fillColor) {
            labelNode.style.setProperty('--tp-swatch-fill', fillColor);
          }
          labelNode.classList.add('tp-swatch-ready');
        });
      }

      function syncTeeinbluePhotoUploadState(rootNode) {
        if (!rootNode) return;
        var photoBlocks = rootNode.querySelectorAll('.tee-photo');
        photoBlocks.forEach(function(photoNode) {
          var hasUploadedPhoto = !!photoNode.querySelector('.tee-photo-label .tee-photo-uploaded, .tee-photo-uploaded');
          var hasUploadInProgress = !!photoNode.querySelector('.tee-photo-label .tee-photo-uploading, .tee-photo-uploading');
          photoNode.classList.toggle('tp-tee-photo-uploaded', hasUploadedPhoto);
          photoNode.classList.toggle('tp-tee-uploading', hasUploadInProgress);
        });
      }

      function syncTeeinbluePriceStyles(rootNode) {
        if (!rootNode) return;
        var campaignRoot = rootNode.closest('.tee-customization-wrapper, .tee-campaign');
        var priceBlock = rootNode.querySelector('.tee-block.tee-product-price');
        if (!priceBlock) {
          if (campaignRoot) {
            priceBlock = campaignRoot.querySelector('.tee-block.tee-product-price');
          }
        }
        if (!priceBlock && sectionRoot) {
          priceBlock = sectionRoot.querySelector('.tee-block.tee-product-price');
        }
        if (!priceBlock) return;

        function getNativePriceWrapper() {
          if (!sectionRoot) return null;
          var infoContainer = sectionRoot.querySelector('.product__info-container');
          if (infoContainer) {
            var infoChildren = infoContainer.children || [];
            for (var childIndex = 0; childIndex < infoChildren.length; childIndex += 1) {
              var childNode = infoChildren[childIndex];
              if (
                childNode &&
                childNode.classList &&
                childNode.classList.contains('no-js-hidden') &&
                childNode.classList.contains('price-wrapper')
              ) {
                return childNode;
              }
            }

            var nestedNativeWrapper = infoContainer.querySelector('.no-js-hidden.price-wrapper[id^="price-"]');
            if (nestedNativeWrapper) return nestedNativeWrapper;

            nestedNativeWrapper = infoContainer.querySelector('.no-js-hidden.price-wrapper');
            if (nestedNativeWrapper) return nestedNativeWrapper;
          }

          return sectionRoot.querySelector('.no-js-hidden.price-wrapper[id^="price-"], .no-js-hidden.price-wrapper');
        }

        function setNativePriceVisibility(isVisible) {
          var nativeWrapper = getNativePriceWrapper();
          if (!nativeWrapper) return;
          if (isVisible) {
            nativeWrapper.style.removeProperty('display');
            return;
          }
          nativeWrapper.style.setProperty('display', 'none', 'important');
        }

        function normalizePriceText(rawText) {
          return (rawText || '').replace(/\s+/g, ' ').trim();
        }

        function getPriceTextFromNode(node) {
          if (!node) return '';
          return normalizePriceText(node.textContent || node.innerText || '');
        }

        var wrappers = priceBlock.querySelectorAll('.tee-price-wrapper');
        var primaryWrapper = null;
        wrappers.forEach(function(wrapperNode) {
          var orderValue = (wrapperNode.getAttribute('style') || '').toLowerCase();
          if (!primaryWrapper && (orderValue.indexOf('order:1') !== -1 || orderValue.indexOf('order: 1') !== -1)) {
            primaryWrapper = wrapperNode;
          }
        });
        if (!primaryWrapper && wrappers.length) {
          primaryWrapper = wrappers[0];
        }
        if (!primaryWrapper) {
          primaryWrapper = document.createElement('div');
          primaryWrapper.className = 'tee-price-wrapper';
          priceBlock.insertBefore(primaryWrapper, priceBlock.firstChild);
        }

        wrappers.forEach(function(wrapperNode) {
          if (wrapperNode !== primaryWrapper && wrapperNode.classList.contains('tp-tee-price-primary-wrapper')) {
            wrapperNode.classList.remove('tp-tee-price-primary-wrapper');
          }
        });
        if (!primaryWrapper.classList.contains('tp-tee-price-primary-wrapper')) {
          primaryWrapper.classList.add('tp-tee-price-primary-wrapper');
        }

        var displayNode = primaryWrapper.querySelector('.tp-tee-price-display[data-tp-price-display="true"]');
        if (!displayNode) {
          displayNode = document.createElement('span');
          displayNode.className =
            'money theme-money price tee-price--current tp-tee-price-current tp-tee-price-display';
          displayNode.setAttribute('data-tp-price-display', 'true');
          primaryWrapper.appendChild(displayNode);
        }

        var staleDisplayNodes = priceBlock.querySelectorAll('.tp-tee-price-display[data-tp-price-display="true"]');
        staleDisplayNodes.forEach(function(node) {
          if (node !== displayNode) node.remove();
        });

        var priceText = '';
        var resolvedFromTeeSource = false;
        var cachedPriceText = normalizePriceText(priceBlock.dataset.tpLastResolvedPrice || '');
        var hasResolvedTeePrice = priceBlock.dataset.tpHasResolvedTeePrice === '1';

        var localCandidates = primaryWrapper.querySelectorAll(
          '.tp-tee-price-current, .tee-price--current, [data-variant-price], .money.theme-money.price'
        );
        for (var localIndex = 0; localIndex < localCandidates.length; localIndex += 1) {
          var localNode = localCandidates[localIndex];
          if (!localNode || localNode === displayNode || localNode.classList.contains('tp-tee-price-display')) continue;
          priceText = getPriceTextFromNode(localNode);
          if (priceText) {
            resolvedFromTeeSource = true;
            break;
          }
        }

        if (!priceText) {
          var internalCandidates = priceBlock.querySelectorAll(
            '.tp-tee-price-current, .tee-price--current, [data-variant-price], .money.theme-money.price'
          );
          for (var internalIndex = 0; internalIndex < internalCandidates.length; internalIndex += 1) {
            var internalNode = internalCandidates[internalIndex];
            if (
              !internalNode ||
              internalNode === displayNode ||
              internalNode.classList.contains('tp-tee-price-display')
            ) {
              continue;
            }
            priceText = getPriceTextFromNode(internalNode);
            if (priceText) {
              resolvedFromTeeSource = true;
              break;
            }
          }
        }

        if (!priceText) {
          var searchRoot = campaignRoot || rootNode;
          var externalCandidates = searchRoot.querySelectorAll(
            '.tp-tee-price-current, .tee-price--current, [data-variant-price], .money.theme-money.price'
          );
          for (var candidateIndex = 0; candidateIndex < externalCandidates.length; candidateIndex += 1) {
            var candidateNode = externalCandidates[candidateIndex];
            if (!candidateNode || candidateNode === displayNode || priceBlock.contains(candidateNode)) continue;
            if (
              candidateNode.closest(
                '.product-recommendations-component, .tapanda-inline-discount, [data-tapanda-shipping-cutoff], .product__info-as-bottom-tabs, .product__accordion'
              )
            ) {
              continue;
            }
            priceText = getPriceTextFromNode(candidateNode);
            if (priceText) {
              resolvedFromTeeSource = true;
              break;
            }
          }
        }

        if (!priceText) {
          priceText = getPriceTextFromNode(displayNode);
        }

        if (!priceText && cachedPriceText) {
          priceText = cachedPriceText;
        }

        var previousActiveNodes = priceBlock.querySelectorAll('.tp-tee-price-current');
        previousActiveNodes.forEach(function(node) {
          if (node !== displayNode) node.classList.remove('tp-tee-price-current');
        });

        var redundantPriceNodes = priceBlock.querySelectorAll(
          '.tp-tee-price-current, .tee-price--current, [data-variant-price], .money.theme-money.price'
        );
        redundantPriceNodes.forEach(function(node) {
          if (!node || node === displayNode || node.classList.contains('tp-tee-price-display')) return;
          node.style.setProperty('display', 'none', 'important');
          node.classList.remove('tp-tee-price-current');
        });
        displayNode.style.removeProperty('display');

        if (!priceText) {
          if (displayNode.textContent !== '') displayNode.textContent = '';
          if (hasResolvedTeePrice || cachedPriceText) {
            setNativePriceVisibility(false);
            if (priceBlock.dataset.tpPriceRetryPending !== '1') {
              priceBlock.dataset.tpPriceRetryPending = '1';
              setTimeout(function() {
                priceBlock.dataset.tpPriceRetryPending = '0';
                syncTeeinbluePriceStyles(rootNode);
              }, 140);
            }
            return;
          }
          setNativePriceVisibility(true);
          return;
        }

        if (displayNode.textContent !== priceText) displayNode.textContent = priceText;
        if (!displayNode.classList.contains('tp-tee-price-current')) {
          displayNode.classList.add('tp-tee-price-current');
        }
        displayNode.style.setProperty('font-family', 'var(--font-body-family), "Urbanist", sans-serif', 'important');
        displayNode.style.setProperty('font-weight', '700', 'important');
        displayNode.style.setProperty('color', '#ba7a4b', 'important');
        /* Keep this override user-adjustable. WCAG text-spacing styles must be
           able to replace it, so it intentionally has no `!important`. */
        displayNode.style.setProperty('letter-spacing', '0.01em');
        priceBlock.dataset.tpLastResolvedPrice = priceText;
        if (resolvedFromTeeSource) {
          priceBlock.dataset.tpHasResolvedTeePrice = '1';
        }
        priceBlock.dataset.tpPriceRetryPending = '0';
        setNativePriceVisibility(false);
      }

      function ensureHiddenTemplateSelection(rootNode) {
        if (!rootNode) return;
        var templateSelects = rootNode.querySelectorAll('.tee-field--template select, select[id$="-template"]');
        templateSelects.forEach(function(selectNode) {
          if (!selectNode || selectNode.disabled) return;
          var currentValue = String(selectNode.value || '').trim().toLowerCase();
          if (currentValue && currentValue !== 'null') return;

          var options = Array.from(selectNode.options || []);
          var fallbackOption = options.find(function(optionNode) {
            if (!optionNode) return false;
            if (optionNode.disabled) return false;
            var optionValue = String(optionNode.value || '').trim().toLowerCase();
            return optionValue && optionValue !== 'null';
          });
          if (!fallbackOption) return;

          selectNode.value = fallbackOption.value;
          selectNode.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      function moveVariantBlocksIntoForm() {
        var forms = getTeeFormNodes(sectionRoot);
        if (!forms.length) return;

        forms.forEach(function(formNode) {
          var destination = getFormDestination(formNode);
          var candidates = [];
          var parentNode = formNode.parentElement;

          if (parentNode) {
            Array.from(parentNode.children).forEach(function(child) {
              if (isVariantBlock(child)) candidates.push(child);
            });
          }

          var nextSibling = formNode.nextElementSibling;
          while (nextSibling) {
            if (isVariantBlock(nextSibling)) candidates.push(nextSibling);
            nextSibling = nextSibling.nextElementSibling;
          }

          var fallbackVariant = sectionRoot.querySelector('.tee-block.tee-variants, .tee-variants');
          if (fallbackVariant) candidates.push(fallbackVariant);

          var uniqueCandidates = [];
          candidates.forEach(function(variantBlock) {
            if (!variantBlock) return;
            if (uniqueCandidates.indexOf(variantBlock) === -1) uniqueCandidates.push(variantBlock);
          });

          for (var i = uniqueCandidates.length - 1; i >= 0; i--) {
            var variantBlock = uniqueCandidates[i];
            if (!variantBlock || formNode.contains(variantBlock)) continue;
            destination.insertBefore(variantBlock, destination.firstElementChild);
            variantBlock.dataset.tpMovedToForm = 'main-product-' + TPMP.sectionId;
          }

          formNode.classList.toggle('tp-tee-has-variants', !!formNode.querySelector('.tee-variants'));
          normalizeTeeinblueOptionTitles(formNode);
          syncTeeinblueColorSwatches(formNode);
          syncTeeinbluePhotoUploadState(formNode);
          ensureHiddenTemplateSelection(formNode);
          syncTeeinbluePriceStyles(formNode);
        });
      }

      function scheduleMove(delay) {
        var wait = typeof delay === 'number' ? delay : 90;
        if (mutationTimeout) {
          window.clearTimeout(mutationTimeout);
          mutationTimeout = null;
        }

        function runMove() {
          if (mutationFrame) return;
          mutationFrame = window.requestAnimationFrame(function() {
            mutationFrame = null;
            if (window.__tpVariantObserver) { window.__tpVariantObserver.disconnect(); }
            try {
              moveVariantBlocksIntoForm();
            } finally {
              if (window.__tpVariantObserver) { window.__tpVariantObserver.observe(sectionRoot, { childList: true, subtree: true }); }
            }
          });
        }

        if (wait <= 0) {
          runMove();
          return;
        }

        mutationTimeout = window.setTimeout(function() {
          mutationTimeout = null;
          runMove();
        }, wait);
      }

      scheduleMove(0);
      window.setTimeout(function() { scheduleMove(0); }, 300);
      window.setTimeout(function() { scheduleMove(0); }, 900);
      window.setTimeout(function() { scheduleMove(0); }, 1800);

      document.addEventListener('teeinblue:ready', function() { scheduleMove(0); });
      document.addEventListener('teeinblue:product-updated', function() { scheduleMove(80); });
      window.addEventListener('tapanda:tib-ready', function() { scheduleMove(0); });

      if (typeof MutationObserver !== 'undefined') {
        window.__tpVariantObserver = new MutationObserver(function(records) {
          if (!mutationBatchTouchesTeeinblue(records)) return;
          scheduleMove(120);
        });
        window.__tpVariantObserver.observe(sectionRoot, { childList: true, subtree: true });
      }

      sectionRoot.__tpMoveVariantBlocksIntoForm = moveVariantBlocksIntoForm;
    }

    function initInlineDiscount() {
      var discountStateKey = 'tapanda_discount_state_v1';
      var discountStateMaxAge = 1000 * 60 * 60 * 2;
      var sectionId = TPMP.sectionId;
      var sectionRoot = document.getElementById('MainProduct-' + sectionId);
      var variants = TPMP.variants;
      var variantPriceMap = {};
      if (Array.isArray(variants)) {
        variants.forEach(function(variant) {
          if (!variant || !variant.id) return;
          variantPriceMap[String(variant.id)] = Number(variant.price || 0);
        });
      }

      function updateDocumentDiscountClass(isActive) {
        document.documentElement.classList.toggle('tapanda-discount-active', !!isActive);
      }

      function getStorage(type) {
        try {
          return window[type];
        } catch (error) {
          return null;
        }
      }

      function getStateExpiresAt(state) {
        if (!state || !state.appliedAt) return null;
        var explicitExpiresAt = Number(state.expiresAt || 0);
        if (isFinite(explicitExpiresAt) && explicitExpiresAt > 0) {
          return explicitExpiresAt;
        }
        var appliedAt = Number(state.appliedAt);
        if (!isFinite(appliedAt) || appliedAt <= 0) return null;
        return appliedAt + discountStateMaxAge;
      }

      function readDiscountState() {
        var storedValue = null;
        var session = getStorage('sessionStorage');
        var local = getStorage('localStorage');

        if (session) storedValue = session.getItem(discountStateKey);
        if (!storedValue && local) storedValue = local.getItem(discountStateKey);
        if (!storedValue) return null;

        try {
          var parsed = JSON.parse(storedValue);
          if (!parsed || !parsed.code || !parsed.appliedAt) return null;
          var expiresAt = getStateExpiresAt(parsed);
          if (!expiresAt || Date.now() >= expiresAt) return null;
          return parsed;
        } catch (error) {
          return null;
        }
      }

      function broadcastDiscountState(state) {
        try {
          window.dispatchEvent(new CustomEvent('tapanda:discount-state', { detail: state || null }));
        } catch (error) {
          // no-op
        }
      }

      function setDiscountState(code, source, discountPercent) {
        if (!code) return null;
        var appliedAt = Date.now();
        var payload = {
          code: String(code).trim().toUpperCase(),
          source: source || 'product_inline_discount',
          percent: Number(discountPercent || 10),
          appliedAt: appliedAt,
          expiresAt: appliedAt + discountStateMaxAge
        };
        var serialized = JSON.stringify(payload);
        var session = getStorage('sessionStorage');
        var local = getStorage('localStorage');
        if (session) session.setItem(discountStateKey, serialized);
        if (local) local.setItem(discountStateKey, serialized);
        updateDocumentDiscountClass(true);
        broadcastDiscountState(payload);
        return payload;
      }

      function clearDiscountState() {
        var session = getStorage('sessionStorage');
        var local = getStorage('localStorage');
        if (session) session.removeItem(discountStateKey);
        if (local) local.removeItem(discountStateKey);
        updateDocumentDiscountClass(false);
        broadcastDiscountState(null);
      }

      if (typeof window.tapandaSetDiscountState !== 'function') {
        window.tapandaSetDiscountState = setDiscountState;
      }
      if (typeof window.tapandaGetDiscountState !== 'function') {
        window.tapandaGetDiscountState = readDiscountState;
      }
      if (typeof window.tapandaClearDiscountState !== 'function') {
        window.tapandaClearDiscountState = clearDiscountState;
      }

      function getCurrentVariantId() {
        var scopedInput = sectionRoot
          ? sectionRoot.querySelector('form[action*="/cart/add"] input[name="id"]')
          : null;
        if (scopedInput && scopedInput.value) {
          return String(scopedInput.value);
        }
        var fallbackInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (!fallbackInput || !fallbackInput.value) return null;
        return String(fallbackInput.value);
      }

      function parsePriceTextToCents(textValue) {
        var raw = String(textValue || '').replace(/\s+/g, '').replace(/[^\d,.-]/g, '');
        if (!raw) return null;

        var lastComma = raw.lastIndexOf(',');
        var lastDot = raw.lastIndexOf('.');
        var separatorIndex = Math.max(lastComma, lastDot);
        var normalized = '';

        if (separatorIndex > -1) {
          var integerPart = raw.slice(0, separatorIndex).replace(/[^\d-]/g, '');
          var decimalPart = raw.slice(separatorIndex + 1).replace(/[^\d]/g, '');
          normalized = integerPart + '.' + decimalPart;
        } else {
          normalized = raw.replace(/[^\d-]/g, '');
        }

        var numericValue = Number(normalized);
        if (!isFinite(numericValue)) return null;
        return Math.round(numericValue * 100);
      }

      function isElementVisible(node) {
        if (!node) return false;
        var current = node;
        while (current && current !== document.documentElement) {
          var style = window.getComputedStyle(current);
          if (!style || style.display === 'none' || style.visibility === 'hidden') {
            return false;
          }
          current = current.parentElement;
        }
        return true;
      }

      function isEligiblePriceNode(node) {
        if (!node) return false;
        if (node.closest('.unit-price')) return false;
        if (node.closest('s')) return false;
        var value = parsePriceTextToCents(node.textContent);
        return isFinite(value) && value > 0;
      }

      function getDisplayPriceNodes() {
        var priceRoot = document.querySelector('#price-' + sectionId + ' .price');
        if (!priceRoot) return [];

        var preferredNodes = Array.from(
          priceRoot.querySelectorAll(
            '.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--sale, .price-item--regular'
          )
        ).filter(isEligiblePriceNode);

        if (!preferredNodes.length) {
          preferredNodes = Array.from(priceRoot.querySelectorAll('.price-item')).filter(isEligiblePriceNode);
        }

        return preferredNodes.filter(function(node, index, collection) {
          return collection.indexOf(node) === index;
        });
      }

      function getCurrentDisplayPriceNode() {
        var priceNodes = getDisplayPriceNodes();
        if (!priceNodes.length) return null;

        var visibleNode = priceNodes.find(function(node) {
          return isElementVisible(node);
        });
        if (visibleNode) return visibleNode;
        return priceNodes[0];
      }

      function getCurrentVariantPriceCents() {
        var variantId = getCurrentVariantId();
        if (variantId && Object.prototype.hasOwnProperty.call(variantPriceMap, variantId)) {
          var mappedPrice = Number(variantPriceMap[variantId]);
          if (isFinite(mappedPrice) && mappedPrice > 0) {
            return mappedPrice;
          }
        }
        var fallbackPriceNode = getCurrentDisplayPriceNode();
        if (!fallbackPriceNode) return null;
        var fallbackText = fallbackPriceNode.dataset.inlineDiscountOriginalPrice || fallbackPriceNode.textContent;
        return parsePriceTextToCents(fallbackText);
      }

      function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          var moneyFormat = (window.DT_THEME && window.DT_THEME.moneyFormat) || window.Shopify.money_format;
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return (cents / 100).toFixed(2);
      }

      function getActivePriceNode() {
        return getCurrentDisplayPriceNode();
      }

      function setDisplayedDiscountedPrice(discountedPriceCents, isActive) {
        var priceNodes = getDisplayPriceNodes();
        if (!priceNodes.length) {
          var activePriceNode = getActivePriceNode();
          if (!activePriceNode) return;
          priceNodes = [activePriceNode];
        }

        priceNodes.forEach(function(priceNode) {
          var originalPrice = priceNode.dataset.inlineDiscountOriginalPrice;
          if (!originalPrice) {
            priceNode.dataset.inlineDiscountOriginalPrice = (priceNode.textContent || '').trim();
            originalPrice = priceNode.dataset.inlineDiscountOriginalPrice;
          }

          if (!isActive) {
            if (originalPrice && (priceNode.textContent || '').trim() !== originalPrice) {
              priceNode.textContent = originalPrice;
            }
            return;
          }

          var discountedText = formatMoney(discountedPriceCents);
          if ((priceNode.textContent || '').trim() !== discountedText) {
            priceNode.textContent = discountedText;
          }
        });
      }

      function buildDiscountUrl(code, redirectPath) {
        var currentPath = window.location.pathname + window.location.search + window.location.hash;
        var resolvedRedirectPath = redirectPath || currentPath || '/cart';
        return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(resolvedRedirectPath) + '&v=' + Date.now();
      }

      function redirectToDiscountFlow(code, redirectPath) {
        window.location.assign(buildDiscountUrl(code, redirectPath));
      }

      function applyDiscountWithoutReload(code, redirectPath) {
        var discountUrl = buildDiscountUrl(code, redirectPath);
        return fetch(discountUrl, {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'follow',
          cache: 'no-store'
        }).then(function(response) {
          if (!response.ok) {
            throw new Error('DISCOUNT_APPLY_FAILED');
          }
          return response.text();
        });
      }

      document.querySelectorAll('[data-inline-discount]').forEach(function(box) {
        var code = box.dataset.code || '';
        var normalizedCode = String(code).trim().toUpperCase();
        var discountPercent = Number(box.dataset.discountPercent || 10);
        var applyButton = box.querySelector('[data-inline-discount-apply]');
        var titleNode = box.querySelector('[data-inline-discount-title]');
        var actionsNode = box.querySelector('[data-inline-discount-actions]');
        var legalNode = box.querySelector('[data-inline-discount-legal]');
        var statusNode = box.querySelector('[data-inline-discount-status]');
        var countdownNode = box.querySelector('[data-inline-discount-countdown]');
        var priceNode = box.querySelector('[data-inline-discount-price]');
        var priceValueNode = box.querySelector('[data-inline-discount-price-value]');
        if (!applyButton || !normalizedCode) return;

        if (box.dataset.bound === '1') return;
        box.dataset.bound = '1';

        var defaultTitleHtml = titleNode ? titleNode.innerHTML : '';
        var defaultApplyLabel = applyButton ? applyButton.textContent.trim() : '';
        var applyingApplyLabel = 'Aktywuje kod...';
        var applyRequestInFlight = false;
        var countdownTimerId = null;

        function track(eventName, payload) {
          if (window.tapandaTrack) {
            window.tapandaTrack(eventName, payload);
          }
        }

        function formatCountdownTime(millisecondsLeft) {
          var totalSeconds = Math.max(0, Math.floor(millisecondsLeft / 1000));
          var hours = Math.floor(totalSeconds / 3600);
          var minutes = Math.floor((totalSeconds % 3600) / 60);
          var seconds = totalSeconds % 60;
          return [hours, minutes, seconds]
            .map(function(value) {
              return String(value).padStart(2, '0');
            })
            .join(':');
        }

        function stopCountdown() {
          if (countdownTimerId) {
            clearInterval(countdownTimerId);
            countdownTimerId = null;
          }
          if (countdownNode) {
            countdownNode.hidden = true;
            countdownNode.textContent = '';
          }
        }

        function renderCountdown(expiresAt) {
          if (!countdownNode || !isFinite(expiresAt)) {
            stopCountdown();
            return;
          }

          var tick = function() {
            var millisecondsLeft = expiresAt - Date.now();
            if (millisecondsLeft <= 0) {
              stopCountdown();
              renderDiscountState();
              return;
            }
            countdownNode.hidden = false;
            countdownNode.innerHTML =
              'Rabat aktywny przez <strong>' + formatCountdownTime(millisecondsLeft) + '</strong>.';
          };

          tick();
          if (countdownTimerId) {
            clearInterval(countdownTimerId);
          }
          countdownTimerId = setInterval(tick, 1000);
        }

        function renderDiscountState() {
          var state =
            typeof window.tapandaGetDiscountState === 'function'
              ? window.tapandaGetDiscountState()
              : readDiscountState();
          var stateExpiresAt = getStateExpiresAt(state);
          var isActive = !!(state && state.code === normalizedCode && stateExpiresAt && stateExpiresAt > Date.now());
          box.classList.toggle('is-active', isActive);
          updateDocumentDiscountClass(isActive);

          if (titleNode) {
            titleNode.classList.remove('is-active');
            titleNode.hidden = isActive;
            if (!isActive && titleNode.innerHTML !== defaultTitleHtml) {
              titleNode.innerHTML = defaultTitleHtml;
            }
          }

          if (actionsNode) {
            actionsNode.hidden = isActive;
          }

          if (applyButton) {
            applyButton.hidden = isActive;
            applyButton.textContent = defaultApplyLabel;
          }

          if (legalNode) {
            legalNode.hidden = isActive;
          }

          if (statusNode) {
            statusNode.classList.toggle('is-success', isActive);
            statusNode.textContent = isActive
              ? discountPercent + '% rabatu naliczone w koszyku.'
              : '';
          }

          if (isActive) {
            renderCountdown(stateExpiresAt);
          } else {
            stopCountdown();
          }

          if (!priceNode || !priceValueNode) return;
          if (!isActive) {
            priceNode.hidden = true;
            setDisplayedDiscountedPrice(0, false);
            return;
          }

          var currentPriceCents = getCurrentVariantPriceCents();
          if (!isFinite(currentPriceCents) || currentPriceCents <= 0) {
            priceNode.hidden = true;
            setDisplayedDiscountedPrice(0, false);
            return;
          }

          var discountedPrice = Math.max(0, Math.round(currentPriceCents * (100 - discountPercent) / 100));
          priceValueNode.textContent = formatMoney(discountedPrice);
          priceNode.hidden = false;
          setDisplayedDiscountedPrice(discountedPrice, true);
        }

        if (applyButton && applyButton.dataset.bound !== '1') {
          applyButton.dataset.bound = '1';
          applyButton.addEventListener('click', function(event) {
            event.preventDefault();
            if (applyRequestInFlight) return;
            applyRequestInFlight = true;

            if (applyButton) {
              applyButton.setAttribute('aria-disabled', 'true');
              applyButton.textContent = applyingApplyLabel;
            }
            if (statusNode) {
              statusNode.classList.remove('is-success');
              statusNode.textContent = 'Aktywuje rabat...';
            }

            applyDiscountWithoutReload(normalizedCode)
              .then(function() {
                if (typeof window.tapandaSetDiscountState === 'function') {
                  window.tapandaSetDiscountState(normalizedCode, 'product_inline_discount', discountPercent);
                } else {
                  setDiscountState(normalizedCode, 'product_inline_discount', discountPercent);
                }
                renderDiscountState();
                track('tapanda_popup_cta_click', {
                  source: 'product_inline_discount',
                  action: 'apply_discount',
                  code: normalizedCode
                });
                track('tapanda_discount_applied', {
                  source: 'product_inline_discount',
                  code: normalizedCode
                });
              })
              .catch(function() {
                if (statusNode) {
                  statusNode.classList.remove('is-success');
                  statusNode.textContent = 'Przekierowuje do koszyka, aby aktywowac rabat...';
                }
                if (applyButton) {
                  applyButton.textContent = defaultApplyLabel;
                }
                setTimeout(function() {
                  redirectToDiscountFlow(normalizedCode);
                }, 120);
              })
              .finally(function() {
                applyRequestInFlight = false;
                if (applyButton) {
                  applyButton.removeAttribute('aria-disabled');
                  if (!box.classList.contains('is-active')) {
                    applyButton.textContent = defaultApplyLabel;
                  }
                }
              });
          });
        }

        if (!box.dataset.discountStateListener) {
          box.dataset.discountStateListener = '1';
          window.addEventListener('tapanda:discount-state', function() {
            renderDiscountState();
          });
        }

        var variantPickerSelector = 'variant-selects[data-section="' + sectionId + '"], variant-radios[data-section="' + sectionId + '"]';
        document.querySelectorAll(variantPickerSelector).forEach(function(variantPicker) {
          if (variantPicker.dataset.inlineDiscountBound === '1') return;
          variantPicker.dataset.inlineDiscountBound = '1';
          variantPicker.addEventListener('change', function() {
            setTimeout(renderDiscountState, 240);
          });
        });

        var variantIdInput = document.querySelector('#product-form-' + sectionId + ' input[name="id"]');
        if (variantIdInput && variantIdInput.dataset.inlineDiscountBound !== '1') {
          variantIdInput.dataset.inlineDiscountBound = '1';
          variantIdInput.addEventListener('change', function() {
            setTimeout(renderDiscountState, 240);
          });
        }

        var priceContainer = document.getElementById('price-' + sectionId);
        if (priceContainer && priceContainer.dataset.inlineDiscountObserved !== '1') {
          priceContainer.dataset.inlineDiscountObserved = '1';
          var priceObserver = new MutationObserver(function() {
            renderDiscountState();
          });
          priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
        }

        renderDiscountState();
      });
    }

    function initTeeinblueGuidedSteps() {
      var sectionRoot = document.getElementById('MainProduct-' + TPMP.sectionId);
      if (!sectionRoot || sectionRoot.dataset.tpGuidedStepsInit === '1') return;
      sectionRoot.dataset.tpGuidedStepsInit = '1';

      var refreshFrame = null;
      var refreshTimeout = null;
      var refreshQueued = false;
      var stepUid = 0;

      function normalizeTeeinblueOptionTitles(rootNode) {
        if (!rootNode) return;
        var optionTitles = rootNode.querySelectorAll('.tee-variants .tee-option__title');
        optionTitles.forEach(function(titleNode) {
          var rawTitle = (titleNode.textContent || '').replace(/[:]/g, '').trim();
          if (!rawTitle) return;
          var normalizedTitle = rawTitle.toLowerCase();
          if (normalizedTitle.indexOf('kolor') === 0) {
            if (titleNode.textContent !== 'Kolor ramki') {
              titleNode.textContent = 'Kolor ramki';
            }
            return;
          }
          if (normalizedTitle.indexOf('rozmiar') === 0) {
            if (titleNode.textContent !== 'Rozmiar obrazu') {
              titleNode.textContent = 'Rozmiar obrazu';
            }
          }
        });

        var sizeLabels = rootNode.querySelectorAll('.tee-option--size .tee-radio-label');
        sizeLabels.forEach(function(labelNode) {
          var valueNode = labelNode.querySelector('span');
          var rawSize = (
            (valueNode ? valueNode.textContent : '') ||
            labelNode.getAttribute('data-title') ||
            labelNode.getAttribute('title') ||
            labelNode.textContent ||
            ''
          )
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();

          var mappedLabel = '';
          var mappedFormat = '';
          if (rawSize.indexOf('a4') === 0) {
            mappedLabel = 'A4 - 20 x 30 cm';
            mappedFormat = 'A4';
          } else if (rawSize.indexOf('a3') === 0) {
            mappedLabel = 'A3 - 30 x 40 cm';
            mappedFormat = 'A3';
          }

          if (!mappedLabel) return;
          var mappedHtml = mappedFormat
            ? '<strong class="tp-size-prefix">' + mappedFormat + '</strong>' + mappedLabel.slice(mappedFormat.length)
            : mappedLabel;

          if (valueNode) {
            if (valueNode.innerHTML !== mappedHtml) {
              valueNode.innerHTML = mappedHtml;
            }
          } else if (labelNode.textContent !== mappedLabel) {
            labelNode.textContent = mappedLabel;
          }
        });
      }

      function getTeeinblueSwatchFillByName(swatchName, fallbackFill) {
        if (!swatchName) return fallbackFill;
        if (swatchName.indexOf('zlot') !== -1 || swatchName.indexOf('gold') !== -1) {
          return 'linear-gradient(145deg, #9a8043 0%, #c2a767 40%, #efe0af 64%, #b49250 100%)';
        }
        if (swatchName.indexOf('srebr') !== -1 || swatchName.indexOf('silver') !== -1) {
          return 'linear-gradient(145deg, #9ea5b0 0%, #c8ced6 40%, #f5f7fa 64%, #aeb5c0 100%)';
        }
        if (swatchName.indexOf('bia') !== -1 || swatchName.indexOf('white') !== -1) {
          return 'linear-gradient(145deg, #ffffff 0%, #f7f5ef 58%, #e8e2d7 100%)';
        }
        if (swatchName.indexOf('czar') !== -1 || swatchName.indexOf('black') !== -1) {
          return 'linear-gradient(145deg, #171920 0%, #2e3138 48%, #0d0f14 100%)';
        }
        return fallbackFill;
      }

      function syncTeeinblueColorSwatches(rootNode) {
        if (!rootNode) return;
        var colorLabels = rootNode.querySelectorAll('.tee-option--color .tee-radio-label');
        colorLabels.forEach(function(labelNode) {
          var swatchNode = labelNode.querySelector('.tee-swatch--color');
          if (!swatchNode) return;
          var fillColor = swatchNode.style && swatchNode.style.backgroundColor ? swatchNode.style.backgroundColor : '';
          if (!fillColor && window.getComputedStyle) {
            fillColor = window.getComputedStyle(swatchNode).backgroundColor;
          }
          var swatchName = (labelNode.getAttribute('title') || labelNode.getAttribute('data-title') || '').toLowerCase();
          if (!fillColor || fillColor === 'transparent' || fillColor === 'rgba(0, 0, 0, 0)') {
            fillColor = '#ffffff';
          }
          fillColor = getTeeinblueSwatchFillByName(swatchName, fillColor);
          if (fillColor) {
            labelNode.style.setProperty('--tp-swatch-fill', fillColor);
          }
          labelNode.classList.add('tp-swatch-ready');
        });
      }

      function isStepNode(node) {
        if (!(
          node &&
          node.nodeType === 1 &&
          node.matches &&
          (node.matches('.tee-option') || node.matches('.tee-field')) &&
          !node.classList.contains('sr-only') &&
          !node.classList.contains('tp-text-step-merged-away') &&
          !node.closest('.sr-only')
        )) return false;

        /* Scrabble-type sub-fields: a .tee-field nested inside a
           .tee-field__subfield of another .tee-field/.tee-option is a
           sub-control of the parent layer, NOT a standalone guided step.
           Treating it as a separate step creates an activation trap:
           expanding the child deactivates the parent, CSS-collapsing
           the child along with it.  Keep it merged into the parent so
           getOwningStepForControl routes its controls to the parent
           and isStepComplete validates them together. */
        if (node.matches('.tee-field') && node.parentElement) {
          var subfieldWrap = node.parentElement.closest
            ? node.parentElement.closest('.tee-field__subfield')
            : null;
          if (subfieldWrap) {
            var outerField = subfieldWrap.parentElement
              ? subfieldWrap.parentElement.closest('.tee-field, .tee-option')
              : null;
            if (outerField) return false;
          }
        }

        return true;
      }

      function isTextContentStepLabel(labelKey) {
        return !!(labelKey && (labelKey === 'tresc' || labelKey.indexOf('tresc-') === 0));
      }

      function isTextFieldStepLabel(labelKey) {
        if (!labelKey) return false;
        if (labelKey === 'pole-tekstowe' || labelKey.indexOf('pole-tekstowe-') === 0) return true;
        if (labelKey === 'pole-testowe' || labelKey.indexOf('pole-testowe-') === 0) return true;
        if (labelKey.indexOf('pole-') === 0 && (labelKey.indexOf('tekst') !== -1 || labelKey.indexOf('text') !== -1)) {
          return true;
        }
        return false;
      }

      function stepLooksLikeTextInputStep(stepNode) {
        if (!stepNode || !stepNode.querySelector) return false;
        if (isTextContentStepLabel(slugifyStepKey(getStepLabel(stepNode)))) return false;
        if (stepNode.querySelector('.tee-visibility-control, .tp-step-visibility-toggle')) return false;
        
        var label = String(getStepLabel(stepNode) || '').toLowerCase();
        if (label.indexOf('materiał') !== -1 || label.indexOf('material') !== -1) return false;
        if (label.indexOf('kolor') !== -1 || label.indexOf('color') !== -1) return false;
        if (label.indexOf('rozmiar') !== -1 || label.indexOf('size') !== -1) return false;
        
        return !!stepNode.querySelector(
          'input[type="text"]:not([disabled]), textarea:not([disabled]), .tee__input--text'
        );
      }

      function isTextFontStepLabel(labelKey) {
        if (!labelKey) return false;
        if (labelKey === 'wybierz-czcionke' || labelKey.indexOf('wybierz-czcionke') === 0) return true;
        if (labelKey.indexOf('czcionk') !== -1) return true;
        return false;
      }

      function stepLooksLikeFontPicker(stepNode) {
        if (!stepNode || !stepNode.querySelector) return false;
        if (isTextFontStepLabel(slugifyStepKey(getStepLabel(stepNode)))) return true;
        var labelText = String(getStepLabel(stepNode) || '').toLowerCase();
        if (labelText.indexOf('czcionk') !== -1) return true;
        var fontLikeLabels = 0;
        var radioLabels = stepNode.querySelectorAll('.tee-radio-label');
        for (var index = 0; index < radioLabels.length; index += 1) {
          var radioLabel = radioLabels[index];
          var sample = String(
            (radioLabel.getAttribute('title') || '') + ' ' + (radioLabel.textContent || '')
          ).trim();
          if (/Regular|VariableFont|Brush|Italic|Sans|Serif/i.test(sample)) {
            fontLikeLabels += 1;
          }
        }
        return fontLikeLabels >= 2;
      }

      function stepHasFontPickerSelection(stepNode) {
        if (!stepNode || !stepNode.querySelector) return false;
        var scopeNodes = [stepNode];
        var mergedFonts = stepNode.querySelector('.tp-merged-text-fonts, .tp-merged-text-inputs');
        if (mergedFonts) scopeNodes.push(mergedFonts);

        for (var scopeIndex = 0; scopeIndex < scopeNodes.length; scopeIndex += 1) {
          var scopeNode = scopeNodes[scopeIndex];
          var radios = scopeNode.querySelectorAll('input[type="radio"]');
          for (var radioIndex = 0; radioIndex < radios.length; radioIndex += 1) {
            var radioNode = radios[radioIndex];
            if (!radioNode || radioNode.disabled) continue;
            if (radioNode.closest('.tee-toggle-wrapper, .tee-visibility-control, .tp-step-visibility-toggle, .tp-step-visibility-radios')) {
              continue;
            }
            var radioLabel = radioNode.id
              ? scopeNode.querySelector('label[for="' + radioNode.id + '"]')
              : radioNode.closest('label');
            if (radioLabel && isTextVisibilityChoiceLabelNode(radioLabel)) continue;
            if (radioNode.checked) return true;
          }
          var selectedFontLabels = scopeNode.querySelectorAll(
            '.tee-radio.active .tee-radio-label, .tee-radio-label.tee-clipart-bubble--enable, .tee-radio input:checked + .tee-radio-label, input[type="radio"]:checked + .tee-radio-label'
          );
          for (var labelIndex = 0; labelIndex < selectedFontLabels.length; labelIndex += 1) {
            if (!isTextVisibilityChoiceLabelNode(selectedFontLabels[labelIndex])) return true;
          }
        }
        return false;
      }

      function isTextMergeSatellite(stepNode) {
        if (!stepNode) return false;
        
        var formNode = getTeeFormNode(stepNode);
        if (formNode && formNode.querySelector('.tee-scrabble-wrapper')) return false;

        var label = String(getStepLabel(stepNode) || '').toLowerCase();
        if (
          label.indexOf('materiał') !== -1 || label.indexOf('materia') !== -1 || label.indexOf('material') !== -1 ||
          label.indexOf('kolor') !== -1 || label.indexOf('color') !== -1 ||
          label.indexOf('rozmiar') !== -1 || label.indexOf('size') !== -1 ||
          label.indexOf('ramka') !== -1 || label.indexOf('frame') !== -1 ||
          label.indexOf('wariant') !== -1 || label.indexOf('variant') !== -1 ||
          label.indexOf('styl') !== -1 || label.indexOf('style') !== -1 ||
          label.indexOf('opakowanie') !== -1 || label.indexOf('packaging') !== -1 ||
          label.indexOf('piosenka') !== -1 || label.indexOf('wyszukaj') !== -1 ||
          label.indexOf('song') !== -1 || label.indexOf('spotify') !== -1 ||
          label.indexOf('liter') !== -1 || label.indexOf('kafelk') !== -1
        ) {
          return false;
        }

        var labelKey = slugifyStepKey(getStepLabel(stepNode));
        if (isTextFieldStepLabel(labelKey) || isTextFontStepLabel(labelKey)) return true;
        if (stepLooksLikeTextInputStep(stepNode)) return true;
        return stepLooksLikeFontPicker(stepNode);
      }

      function stepHasTextVisibilityControls(stepNode) {
        if (!stepNode) return false;
        return !!(
          getStepVisibilityToggleControl(stepNode) ||
          getTextVisibilityRadioNodes(stepNode).length
        );
      }

      function findTextMergeGroup(formNode) {
        if (!formNode || !formNode.querySelectorAll) return null;
        var hostStep = null;
        var satelliteSteps = [];
        var poleSteps = [];
        var trescSteps = [];
        var visibilitySteps = [];
        var candidateSteps = Array.from(formNode.querySelectorAll('.tee-option, .tee-field')).filter(function(stepNode) {
          return isStepNode(stepNode) && !stepNode.classList.contains('tp-text-step-merged-away');
        });

        if (!candidateSteps.length) return null;

        candidateSteps.forEach(function(stepNode) {
          var labelKey = slugifyStepKey(getStepLabel(stepNode));
          if (isTextFieldStepLabel(labelKey)) {
            poleSteps.push(stepNode);
            return;
          }
          if (isTextContentStepLabel(labelKey)) {
            trescSteps.push(stepNode);
            return;
          }
          if (stepHasTextVisibilityControls(stepNode)) {
            visibilitySteps.push(stepNode);
          }
        });

        /* Host = „Pole tekstowe” (z przełącznikiem Dodaj/Ukryj w nagłówku lub w scalonej treści). */
        if (poleSteps.length) {
          var poleIndex;
          for (poleIndex = 0; poleIndex < poleSteps.length; poleIndex += 1) {
            if (stepHasTextVisibilityControls(poleSteps[poleIndex])) {
              hostStep = poleSteps[poleIndex];
              break;
            }
          }
          if (!hostStep) hostStep = poleSteps[0];
        }

        if (!hostStep && trescSteps.length) {
          var trescIndex;
          for (trescIndex = 0; trescIndex < trescSteps.length; trescIndex += 1) {
            if (stepHasTextVisibilityControls(trescSteps[trescIndex])) {
              hostStep = trescSteps[trescIndex];
              break;
            }
          }
          if (!hostStep) hostStep = trescSteps[0];
        }

        if (!hostStep && visibilitySteps.length) {
          hostStep = visibilitySteps[0];
        }

        if (!hostStep) return null;

        candidateSteps.forEach(function(stepNode) {
          if (stepNode === hostStep) return;
          var labelKey = slugifyStepKey(getStepLabel(stepNode));
          if (
            isTextContentStepLabel(labelKey) ||
            isTextFieldStepLabel(labelKey) ||
            isTextFontStepLabel(labelKey) ||
            isTextMergeSatellite(stepNode)
          ) {
            satelliteSteps.push(stepNode);
          }
        });

        if (!satelliteSteps.length) return null;
        return { hostStep: hostStep, satelliteSteps: satelliteSteps };
      }

      function ensureTextVisibilityControlsInHeader(stepNode) {
        if (!stepNode) return;
        var formNode = getTeeFormNode(stepNode);
        var headerNode = stepNode.querySelector('.tee-field__header, .tee-option__title');
        if (!headerNode) return;

        stepNode.querySelectorAll('.tee-toggle-wrapper.tee-visibility-control, .tp-step-visibility-toggle').forEach(function(toggleNode) {
          if (!headerNode.contains(toggleNode)) {
            headerNode.appendChild(toggleNode);
          }
        });

        var visibilityRadios = getTextVisibilityRadioNodes(stepNode);
        if (!visibilityRadios.length) return;

        var radioHost = visibilityRadios[0].closest(
          '.tee-field__content, .tee-field__input, .tee-field__body, .tee-option__content, .tee-visibility-control'
        );
        if (radioHost && !headerNode.contains(radioHost)) {
          radioHost.classList.add('tp-step-visibility-radios');
          headerNode.appendChild(radioHost);
        }
      }

      function ensureMergedTextToggleInHeader(hostStep) {
        if (!hostStep) return;
        ensureTextVisibilityControlsInHeader(hostStep);
        syncStepVisibilityToggle(hostStep);
      }

      function guardMergedTextStepShell(hostStep) {
        if (!hostStep || hostStep.dataset.tpTextMerged !== '1') return;
        var formNode = getTeeFormNode(hostStep);
        if (!formHasUploadedPhoto(formNode)) {
          hostStep.classList.remove('tp-text-step-merged-away');
          hostStep.removeAttribute('hidden');
          hostStep.style.setProperty('display', 'block', 'important');
          hostStep.style.setProperty('visibility', 'visible', 'important');
          hostStep.style.setProperty('opacity', '1', 'important');
          hostStep.style.setProperty('height', 'auto', 'important');
          hostStep.style.setProperty('max-height', 'none', 'important');
          hostStep.style.setProperty('overflow', 'visible', 'important');
          hostStep.style.setProperty('pointer-events', 'auto', 'important');

          var waitingHeaderNode = hostStep.querySelector(':scope > .tee-field__header, :scope > .tee-option__title');
          if (waitingHeaderNode) {
            waitingHeaderNode.style.setProperty('display', 'flex', 'important');
            waitingHeaderNode.style.setProperty('visibility', 'visible', 'important');
            waitingHeaderNode.style.removeProperty('height');
          }

          getStepBodyNodes(hostStep).forEach(function(bodyNode) {
            bodyNode.hidden = true;
            bodyNode.style.setProperty('display', 'none', 'important');
          });
          return;
        }
        hostStep.classList.remove('tp-text-step-merged-away');
        hostStep.removeAttribute('hidden');
        hostStep.style.removeProperty('display');
        hostStep.style.removeProperty('visibility');
        hostStep.style.removeProperty('opacity');
        hostStep.style.removeProperty('height');
        hostStep.style.removeProperty('max-height');
        hostStep.style.removeProperty('overflow');
        hostStep.style.removeProperty('pointer-events');
        hostStep.style.setProperty('display', 'block', 'important');
        hostStep.style.setProperty('visibility', 'visible', 'important');
        hostStep.style.setProperty('opacity', '1', 'important');
        hostStep.style.setProperty('height', 'auto', 'important');
        hostStep.style.setProperty('max-height', 'none', 'important');
        var headerNode = hostStep.querySelector(':scope > .tee-field__header, :scope > .tee-option__title');
        if (headerNode) {
          headerNode.style.setProperty('display', 'flex', 'important');
          headerNode.style.setProperty('visibility', 'visible', 'important');
          headerNode.style.removeProperty('height');
        }
        var toggleNode = hostStep.querySelector('.tp-step-visibility-toggle, .tee-toggle-wrapper.tee-visibility-control');
        if (toggleNode) {
          toggleNode.style.setProperty('display', 'flex', 'important');
          toggleNode.style.setProperty('visibility', 'visible', 'important');
        }
        reviveMergedTextInnerSteps(hostStep);
      }

      function reviveMergedTextInnerSteps(hostStep) {
        if (!hostStep || !hostStep.querySelectorAll) return;
        hostStep.querySelectorAll(
          '.tp-merged-text-inputs .tee-field.tp-text-step-merged-away, .tp-merged-text-inputs .tee-option.tp-text-step-merged-away'
        ).forEach(function(innerStep) {
          prepareMergedTextInnerStep(innerStep);
        });
      }

      function classifyMergedTextBodyNode(bodyNode) {
        if (!bodyNode || bodyNode.nodeType !== 1) return;
        bodyNode.classList.remove('tp-merged-text-host-inputs', 'tp-merged-text-fonts', 'tp-step-visibility-radios');
        if (getTextVisibilityRadioNodes(bodyNode).length) {
          bodyNode.classList.add('tp-step-visibility-radios');
          return;
        }
        if (bodyNode.querySelector('.tee-visibility-control, .tp-step-visibility-toggle')) return;
        if (bodyNode.querySelector('input[type="text"], textarea')) {
          bodyNode.classList.add('tp-merged-text-host-inputs');
          return;
        }
        if (stepLooksLikeFontPicker(bodyNode)) {
          bodyNode.classList.add('tp-merged-text-fonts');
          return;
        }
        var fontTileCount = bodyNode.querySelectorAll('.tee-radio-label').length;
        if (
          fontTileCount >= 2 &&
          !bodyNode.querySelector('input[type="text"], textarea, .tee__input--text')
        ) {
          bodyNode.classList.add('tp-merged-text-fonts');
        }
      }

      function prepareMergedTextInnerStep(innerStep) {
        if (!innerStep || !innerStep.classList) return;
        innerStep.classList.add('tp-text-step-merged-away', 'tp-text-step-merged-inner');
        innerStep.classList.remove(
          'tp-guided-step',
          'is-active-step',
          'is-pending-step',
          'is-complete',
          'is-collapsed',
          'is-expanded',
          'tp-validation-error-glow',
          'tp-step-error-glow'
        );
        innerStep.removeAttribute('hidden');
        if (innerStep.dataset) {
          delete innerStep.dataset.tpGuidedStepNumber;
          delete innerStep.dataset.tpGuidedStepTotal;
          delete innerStep.dataset.tpGuidedStepBadge;
          delete innerStep.dataset.tpGuidedTouched;
        }
        innerStep.style.removeProperty('display');
        innerStep.style.removeProperty('visibility');
        innerStep.style.removeProperty('opacity');
        innerStep.style.removeProperty('height');
        innerStep.style.removeProperty('max-height');
        innerStep.style.removeProperty('overflow');
        innerStep.style.removeProperty('pointer-events');

        getStepBodyNodes(innerStep).forEach(function(bodyNode) {
          bodyNode.hidden = false;
          bodyNode.removeAttribute('aria-hidden');
          bodyNode.style.removeProperty('display');
          bodyNode.style.removeProperty('max-height');
          bodyNode.style.removeProperty('overflow');
          bodyNode.style.removeProperty('opacity');
          bodyNode.style.removeProperty('visibility');
          bodyNode.style.removeProperty('pointer-events');
          bodyNode.style.removeProperty('margin');
          bodyNode.style.removeProperty('padding');
        });
      }

      function controlBelongsToMergedTextHost(controlNode, hostStep) {
        if (!controlNode || !hostStep) return false;
        var ownerStep = getOwningStepForControl(controlNode);
        if (ownerStep === hostStep) return true;
        return !!(
          ownerStep &&
          ownerStep.classList &&
          ownerStep.classList.contains('tp-text-step-merged-inner') &&
          hostStep.contains(ownerStep)
        );
      }

      function shouldHideTextStepInputs(stepNode) {
        return getStepVisibilityToggleState(stepNode) === false;
      }

      function captureTextVisibilityModeFromDom(stepNode) {
        if (!stepNode || !stepNode.dataset) return;
        var radioState = getTextVisibilityRadioState(stepNode);
        if (radioState === false) {
          stepNode.dataset.tpTextVisibilityMode = 'hide';
        } else if (radioState === true) {
          stepNode.dataset.tpTextVisibilityMode = 'show';
        }
      }

      function getTextVisibilityInputRegions(stepNode) {
        if (!stepNode) return [];
        var regions = [];
        /* Nie chowaj całego .tp-merged-text-inputs — tylko pola tekstu i sekcję czcionek. */
        var selectors = [
          ':scope > .tee-field__body',
          ':scope > .tee-field__content',
          ':scope > .tee-field__input',
          '.tp-merged-text-host-inputs',
          '.tp-merged-text-fonts'
        ];
        selectors.forEach(function(selector) {
          stepNode.querySelectorAll(selector).forEach(function(regionNode) {
            if (!regionNode || regionNode.closest('.tee-field__header, .tp-step-visibility-toggle, .tee-visibility-control')) {
              return;
            }
            if (regions.indexOf(regionNode) === -1) regions.push(regionNode);
          });
        });
        var mergedWrap = stepNode.querySelector(':scope > .tp-merged-text-inputs');
        if (mergedWrap && regions.indexOf(mergedWrap) === -1) {
          var hasInnerRegions = mergedWrap.querySelector('.tp-merged-text-host-inputs, .tp-merged-text-fonts');
          if (!hasInnerRegions) regions.push(mergedWrap);
        }
        return regions;
      }

      function applyTextVisibilityHiddenState(regionNode, hideInputs) {
        if (!regionNode) return;
        regionNode.classList.toggle('tp-text-input-hidden', hideInputs);
        if (hideInputs) {
          regionNode.setAttribute('aria-hidden', 'true');
          regionNode.removeAttribute('hidden');
          /* Bez inline display:none — kolidowało z rozwijaniem kroku (setStepExpanded). */
          regionNode.style.removeProperty('display');
        } else {
          regionNode.removeAttribute('aria-hidden');
          regionNode.removeAttribute('hidden');
          regionNode.style.removeProperty('display');
          regionNode.style.removeProperty('max-height');
          regionNode.style.removeProperty('overflow');
          regionNode.style.removeProperty('opacity');
          regionNode.style.removeProperty('visibility');
          regionNode.style.removeProperty('pointer-events');
          regionNode.style.removeProperty('margin');
          regionNode.style.removeProperty('padding');
        }
      }

      function syncTextStepInputVisibility(stepNode) {
        if (!stepNode) return;
        var hasVisibilityUi = stepNode.dataset.tpTextMerged === '1' || stepHasTextVisibilityControls(stepNode);
        if (!hasVisibilityUi) return;

        if (!stepNode.dataset.tpTextVisibilityMode) {
          captureTextVisibilityModeFromDom(stepNode);
        }

        var formNode = getTeeFormNode(stepNode);
        var hasPhoto = formHasUploadedPhoto(formNode);
        if (stepNode.dataset.tpTextMerged === '1' || stepHasTextVisibilityControls(stepNode)) {
          ensureTextVisibilityControlsInHeader(stepNode);
          var toggleNodes = stepNode.querySelectorAll('.tp-step-visibility-toggle, .tee-toggle-wrapper.tee-visibility-control, .tp-step-visibility-radios');
          toggleNodes.forEach(function(toggleNode) {
            if (!hasPhoto) {
              toggleNode.style.setProperty('display', 'none', 'important');
            } else {
              toggleNode.style.removeProperty('display');
            }
          });
        }
        guardMergedTextStepShell(stepNode);

        var hideInputs = shouldHideTextStepInputs(stepNode);
        if (isMergedTextHostStep(stepNode)) {
          var mergedExpanded = stepNode.classList.contains('is-expanded');
          if (!formHasUploadedPhoto(formNode) || !mergedExpanded) {
            hideInputs = true;
          }
        }
        stepNode.classList.toggle('tp-text-hide-inputs', hideInputs);
        stepNode.classList.toggle('tp-text-show-inputs', !hideInputs);

        getTextVisibilityInputRegions(stepNode).forEach(function(regionNode) {
          applyTextVisibilityHiddenState(regionNode, hideInputs);
        });

        /* Nie chowaj całego .tp-merged-text-inputs — przełącznik Dodaj/Ukryj i czcionki muszą zostać dostępne. */
        var mergedWrap = stepNode.querySelector(':scope > .tp-merged-text-inputs');
        if (mergedWrap) {
          mergedWrap.classList.remove('tp-text-input-hidden');
          mergedWrap.removeAttribute('aria-hidden');
          mergedWrap.style.removeProperty('display');
          mergedWrap.style.removeProperty('max-height');
          mergedWrap.style.removeProperty('opacity');
          mergedWrap.style.removeProperty('visibility');
          mergedWrap.style.removeProperty('pointer-events');
        }

        ensureMergedTextToggleInHeader(stepNode);
        guardMergedTextStepShell(stepNode);
      }

      function syncMergedTextStepVisibility(hostStep) {
        syncTextStepInputVisibility(hostStep);
      }

      function bindMergedTextHostGuard(hostStep) {
        if (!hostStep || hostStep.__tpMergedTextGuardObs) return;
        var guardTimer = null;
        hostStep.__tpMergedTextGuardObs = new MutationObserver(function(mutations) {
          var onlyHidden = mutations.every(function(mutation) {
            return mutation.type === 'attributes' && mutation.attributeName === 'hidden';
          });
          if (!onlyHidden) return;
          if (hostStep.__tpMergedTextGuardPaused) return;
          if (guardTimer) window.clearTimeout(guardTimer);
          guardTimer = window.setTimeout(function() {
            guardTimer = null;
            hostStep.__tpMergedTextGuardPaused = true;
            try {
              guardMergedTextStepShell(hostStep);
              syncMergedTextStepVisibility(hostStep);
            } finally {
              window.setTimeout(function() {
                hostStep.__tpMergedTextGuardPaused = false;
              }, 0);
            }
          }, 48);
        });
        hostStep.__tpMergedTextGuardObs.observe(hostStep, {
          attributes: true,
          attributeFilter: ['hidden']
        });
      }

      function bindMergedTextToggle(formNode, hostStep) {
        if (!formNode || !hostStep || hostStep.dataset.tpMergedTextToggleBound === '1') return;
        var toggleControl = getStepVisibilityToggleControl(hostStep);
        var textVisibilityRadios = getTextVisibilityRadioNodes(hostStep);
        if (!toggleControl && !textVisibilityRadios.length) return;
        hostStep.dataset.tpMergedTextToggleBound = '1';
        bindMergedTextHostGuard(hostStep);
        function handleMergedTextToggleChange() {
          captureTextVisibilityModeFromDom(hostStep);
          formNode.__tpSkipGuidedScrollOnce = true;
          markStepTouched(hostStep);
          formNode.dataset.tpGuidedActiveStep = ensureStepId(hostStep);
          var expandLockRegistry = getStepExpandLockRegistry(formNode);
          var expandLockKey = getStepExpandLockKey(hostStep);
          if (expandLockRegistry && expandLockKey) {
            expandLockRegistry[expandLockKey] = true;
          }
          setStepExpanded(hostStep, true);
          guardMergedTextStepShell(hostStep);
          ensureTextVisibilityControlsInHeader(hostStep);
          syncMergedTextStepVisibility(hostStep);
          requestSync(formNode, null);
          window.setTimeout(function() {
            guardMergedTextStepShell(hostStep);
            syncMergedTextStepVisibility(hostStep);
          }, 48);
          window.setTimeout(function() {
            guardMergedTextStepShell(hostStep);
            syncMergedTextStepVisibility(hostStep);
          }, 200);
        }
        if (toggleControl) {
          toggleControl.addEventListener('change', handleMergedTextToggleChange);
          toggleControl.addEventListener('click', function() {
            window.setTimeout(handleMergedTextToggleChange, 0);
          });
        }
        textVisibilityRadios.forEach(function(radioNode) {
          radioNode.addEventListener('change', handleMergedTextToggleChange);
          radioNode.addEventListener('click', function() {
            formNode.__tpSkipGuidedScrollOnce = true;
            window.setTimeout(handleMergedTextToggleChange, 0);
          });
        });
        hostStep.querySelectorAll('.tee-radio-label, .tee-visibility-control label').forEach(function(labelNode) {
          if (!isTextVisibilityChoiceLabelNode(labelNode)) return;
          labelNode.addEventListener('click', function() {
            rememberTextVisibilityChoice(hostStep, labelNode);
            formNode.__tpSkipGuidedScrollOnce = true;
            window.setTimeout(handleMergedTextToggleChange, 0);
          });
        });
      }

      function hideTextMergeSatellite(satelliteStep) {
        if (!satelliteStep) return;
        if (
          satelliteStep.closest &&
          satelliteStep.closest('[data-tp-text-merged="1"] .tp-merged-text-inputs')
        ) {
          prepareMergedTextInnerStep(satelliteStep);
          return;
        }
        satelliteStep.classList.add('tp-text-step-merged-away');
        satelliteStep.setAttribute('hidden', '');
        satelliteStep.style.setProperty('display', 'none', 'important');
      }

      function isTeeFormReadyForTextMerge(formNode) {
        return !!(formNode && formNode.__tpTibReady === true);
      }

      function maybeApplyTextStepMerge(formNode) {
        if (!isTeeFormReadyForTextMerge(formNode)) return;
        mergeCoupledTextSteps(formNode);
      }

      function mergeCoupledTextSteps(formNode) {
        if (!formNode || !isTeeFormReadyForTextMerge(formNode)) return;
        var group = findTextMergeGroup(formNode);
        if (!group) return;

        var hostStep = group.hostStep;
        var satelliteSteps = group.satelliteSteps;
        var satelliteIds = satelliteSteps.map(function(stepNode) {
          return ensureStepId(stepNode);
        }).join('|');

        var allSatellitesInHost = true;
        satelliteSteps.forEach(function(satelliteStep) {
          if (satelliteStep !== hostStep && !hostStep.contains(satelliteStep)) {
            allSatellitesInHost = false;
          }
        });

        if (hostStep.dataset.tpTextMerged === '1' && hostStep.dataset.tpTextMergedSatelliteIds === satelliteIds && allSatellitesInHost) {
          ensureMergedTextToggleInHeader(hostStep);
          syncMergedTextStepVisibility(hostStep);
          bindMergedTextToggle(formNode, hostStep);
          return;
        }

        var mergedWrap = hostStep.querySelector('.tp-merged-text-inputs');
        if (!mergedWrap) {
          mergedWrap = document.createElement('div');
          mergedWrap.className = 'tp-merged-text-inputs';
          hostStep.appendChild(mergedWrap);
        }

        satelliteSteps.forEach(function(satelliteStep) {
          if (satelliteStep === hostStep) return;
          
          var satelliteId = ensureStepId(satelliteStep);
          var existingNodes = Array.from(mergedWrap.children).filter(function(child) {
            return ensureStepId(child) === satelliteId && child !== satelliteStep;
          });
          existingNodes.forEach(function(node) {
            node.remove();
          });

          /* Przenosimy caly root pola, nie samo body: Teeinblue trzyma stan i listenery na komponencie pola. */
          classifyMergedTextBodyNode(satelliteStep);
          prepareMergedTextInnerStep(satelliteStep);
          mergedWrap.appendChild(satelliteStep);
        });

        getStepBodyNodes(hostStep).forEach(function(bodyNode) {
          if (mergedWrap.contains(bodyNode)) return;
          classifyMergedTextBodyNode(bodyNode);
        });

        hostStep.dataset.tpTextMerged = '1';
        hostStep.dataset.tpTextMergedSatelliteIds = satelliteIds;
        ensureMergedTextToggleInHeader(hostStep);
        syncMergedTextStepVisibility(hostStep);
        bindMergedTextToggle(formNode, hostStep);
        window.setTimeout(function() {
          syncFormGuidedState(formNode, null);
        }, 0);
      }

      function isMergedTextHostStep(stepNode) {
        return !!(stepNode && stepNode.dataset && stepNode.dataset.tpTextMerged === '1');
      }

      function isTextCustomizationStep(stepNode) {
        if (!stepNode || !stepNode.classList) return false;
        if (stepNode.classList.contains('tp-birthday-age') || stepNode.querySelector('input.tp-birthday-age[type="number"]')) return false;
        if (stepNode.classList.contains('tee-field--photo')) return false;
        if (isMergedTextHostStep(stepNode)) return true;
        if (stepNode.classList.contains('tee-field--text')) return true;
        var className = stepNode.className || '';
        if (/tee-field--[^\s]+-font\b/.test(className)) return true;
        if (stepHasTextVisibilityControls(stepNode)) return true;
        return false;
      }

      function guardTextCustomizationSteps(formNode) {
        if (!formNode || !formNode.querySelectorAll) return;
        var hasPhoto = formHasUploadedPhoto(formNode);
        formNode.querySelectorAll('.tee-field').forEach(function(stepNode) {
          if (!isTextCustomizationStep(stepNode)) return;
          if (isMergedTextHostStep(stepNode)) {
            guardMergedTextStepShell(stepNode);
            return;
          }
          /* Krok tekstowy bez zdjęcia: widoczny ale zwinięty (nie ukryty).
             syncFormGuidedState() ustawia shouldExpandStep=false — to wystarczy.
             Klasa tp-text-step-awaiting-photo pozwala na wizualne wyciszenie (CSS). */
          stepNode.classList.toggle('tp-text-step-awaiting-photo', !hasPhoto);
          stepNode.style.removeProperty('display');
          stepNode.style.removeProperty('visibility');
          stepNode.style.removeProperty('opacity');
          stepNode.style.removeProperty('height');
          stepNode.style.removeProperty('max-height');
          stepNode.style.removeProperty('overflow');
          stepNode.style.removeProperty('pointer-events');
        });
      }

      function isMergedTextStepComplete(stepNode) {
        if (!stepNode) return false;
        /* Przed uploadem zdjęcia — krok nie jest jeszcze wymagany (widoczny, ale zwinięty), więc nie powinien świecić się na zielono jako ukończony. */
        if (!formHasUploadedPhoto(getTeeFormNode(stepNode))) return false;
        var touched = isStepTouched(stepNode);
        if (shouldHideTextStepInputs(stepNode)) {
          /* Tekst ukryty (toggle „Ukryj tekst”) — wymaga touched. */
          return touched;
        }

        var textControls = Array.from(
          stepNode.querySelectorAll(
            '.tp-merged-text-inputs input[type="text"], .tp-merged-text-inputs textarea, .tp-merged-text-host-inputs input[type="text"], .tp-merged-text-host-inputs textarea, .tee-field__input input[type="text"], .tee-field__input textarea, .tee__input--text'
          )
        ).filter(function(controlNode) {
          if (!controlNode || controlNode.disabled) return false;
          if (controlNode.closest('.tee-toggle-wrapper, .tee-visibility-control, .tp-step-visibility-toggle')) {
            return false;
          }
          return controlBelongsToMergedTextHost(controlNode, stepNode);
        });
        var hasFontUi = !!stepNode.querySelector('.tp-merged-text-fonts');
        if (!textControls.length) {
          if (hasFontUi) return stepHasFontPickerSelection(stepNode);
          return formHasUploadedPhoto(getTeeFormNode(stepNode));
        }
        var hasFilledText = textControls.some(function(controlNode) {
          return isControlFilled(controlNode);
        });
        if (!hasFilledText) return false;
        if (hasFontUi && !stepHasFontPickerSelection(stepNode)) return false;
        return true;
      }

      /** Pierwszy przodek będący krokiem — rozdziela kontrolki zagnieżdżonych warstw (np. Scrabble + materiał liter w subfield). */
      function getOwningStepForControl(controlNode) {
        if (!controlNode) return null;
        var el = controlNode.nodeType === 1 ? controlNode : controlNode.parentElement;
        while (el) {
          if (isStepNode(el)) return el;
          el = el.parentElement;
        }
        return null;
      }

      function slugifyStepKey(rawValue) {
        var normalizedValue = String(rawValue || '').trim().toLowerCase();
        if (!normalizedValue) return '';
        if (normalizedValue.normalize) {
          normalizedValue = normalizedValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }
        return normalizedValue
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 64);
      }

      function getStableStepId(stepNode) {
        if (!stepNode) return '';

        var baseId = stepNode.id ? String(stepNode.id).replace(/[^a-zA-Z0-9_-]/g, '') : '';
        if (baseId) return baseId;

        var classNames = Array.from(stepNode.classList || []);
        var fieldClass = classNames.find(function(className) {
          return className.indexOf('tee-field--') === 0 && className !== 'tee-field';
        });
        if (fieldClass) {
          return fieldClass.replace(/[^a-zA-Z0-9_-]/g, '');
        }

        var optionClass = classNames.find(function(className) {
          return className.indexOf('tee-option--') === 0 && className !== 'tee-option';
        });
        if (optionClass) {
          return optionClass.replace(/[^a-zA-Z0-9_-]/g, '');
        }

        var labelKey = slugifyStepKey(getStepLabel(stepNode));
        if (labelKey) {
          return 'tp-guided-step-' + labelKey;
        }

        return '';
      }

      function ensureStepId(stepNode) {
        if (!stepNode) return '';
        var stableId = getStableStepId(stepNode);
        if (stableId && stepNode.dataset.tpGuidedStepId !== stableId) {
          stepNode.dataset.tpGuidedStepId = stableId;
        }
        if (!stepNode.dataset.tpGuidedStepId) {
          stepUid += 1;
          stepNode.dataset.tpGuidedStepId = 'tp-guided-step-' + stepUid;
        }
        return stepNode.dataset.tpGuidedStepId;
      }

      function getStepNodes(formNode) {
        if (!formNode) return [];
        var steps = Array.from(formNode.querySelectorAll('.tee-option, .tee-field')).filter(function(node) {
          return isStepNode(node);
        });
        var styleStep = null;
        var uploadStep = null;
        steps.forEach(function(stepNode) {
          var label = slugifyStepKey(getStepLabel(stepNode));
          if (!styleStep && (label.indexOf('wybierz-styl') !== -1 || label.indexOf('styl') !== -1)) {
            styleStep = stepNode;
          }
          if (!uploadStep && (label.indexOf('przeslij-zdjecie') !== -1 || label.indexOf('zdjecie') !== -1 || label.indexOf('photo') !== -1)) {
            uploadStep = stepNode;
          }
        });
        if (styleStep && uploadStep && steps.indexOf(styleStep) > steps.indexOf(uploadStep)) {
          uploadStep.parentNode.insertBefore(styleStep, uploadStep);
          steps = Array.from(formNode.querySelectorAll('.tee-option, .tee-field')).filter(function(node) {
            return isStepNode(node);
          });
        }
        return steps;
      }

      function findStepNodeById(formNode, stepId) {
        if (!formNode || !stepId) return null;
        var steps = getStepNodes(formNode);
        for (var index = 0; index < steps.length; index += 1) {
          var stepNode = steps[index];
          if (ensureStepId(stepNode) === stepId) {
            return stepNode;
          }
        }
        return null;
      }

      function getStepHeader(stepNode) {
        if (!stepNode) return null;
        if (stepNode.classList.contains('tee-option')) {
          return stepNode.querySelector('.tee-option__title');
        }
        return stepNode.querySelector('.tee-field__header') || stepNode.querySelector('.tee-field__heading');
      }

      function getStepBodyNodes(stepNode) {
        if (!stepNode) return [];
        var bodyNodes = [];
        Array.from(stepNode.children || []).forEach(function(childNode) {
          if (!childNode || childNode.nodeType !== 1) return;
          if (childNode.classList.contains('tee-field__header') || childNode.classList.contains('tee-option__title')) return;
          bodyNodes.push(childNode);
        });
        return bodyNodes;
      }

      function syncStepVisibilityToggle(stepNode) {
        if (!stepNode || !stepNode.classList.contains('tee-field')) return;
        ensureTextVisibilityControlsInHeader(stepNode);
        var headerNode = stepNode.querySelector('.tee-field__header');
        if (!headerNode) return;

        var toggleNode = stepNode.querySelector('.tee-toggle-wrapper.tee-visibility-control');
        if (!toggleNode) return;

        headerNode.classList.add('tp-step-header-with-toggle');
        toggleNode.classList.add('tp-step-visibility-toggle');

        var headingNode = headerNode.querySelector('.tee-field__heading');
        if (headingNode) {
          headingNode.classList.add('tp-step-header-heading');
        }
      }

      function normalizeStepLabel(rawText) {
        return String(rawText || '')
          .replace(/\s+/g, ' ')
          .replace(/^\s*\d+\s*[\.\)]\s*/, '')
          .trim();
      }

      function getStepLabel(stepNode) {
        if (!stepNode) return '';
        var labelNode = null;
        if (stepNode.classList.contains('tee-option')) {
          labelNode = stepNode.querySelector('.tee-option__title');
        } else {
          labelNode = stepNode.querySelector('.tee-field__heading') || stepNode.querySelector('.tee-field__header');
        }
        return normalizeStepLabel(labelNode ? labelNode.textContent : '');
      }

      /* Krok „Chcesz dodać własne zmiany?" — wykrywany po tytule (odporny na polskie znaki). */
      function isCustomChangesStep(stepNode) {
        if (!stepNode) return false;
        var label = (getStepLabel(stepNode) || '').toLowerCase();
        return label.indexOf('własne zmiany') !== -1 || label.indexOf('wlasne zmiany') !== -1;
      }

      function ensureGuidedProgressNode(formNode) {
        if (!formNode) return null;
        var progressNodes = formNode.querySelectorAll('.tp-guided-progress');
        progressNodes.forEach(function(node) {
          if (node && node.parentNode) node.parentNode.removeChild(node);
        });
        return null;
      }

      function syncGuidedProgressNode(formNode) {
        ensureGuidedProgressNode(formNode);
      }

      function isControlFilled(controlNode) {
        if (!controlNode) return true;
        var tagName = String(controlNode.tagName || '').toLowerCase();
        var type = String(controlNode.type || '').toLowerCase();

        if (type === 'radio') {
          return !!controlNode.checked;
        }
        if (type === 'checkbox') {
          return !!controlNode.checked;
        }
        if (type === 'file') {
          return !!(controlNode.files && controlNode.files.length);
        }
        if (tagName === 'select') {
          var selectValue = String(controlNode.value || '').trim().toLowerCase();
          return !!selectValue && selectValue !== 'null';
        }
        var value = String(controlNode.value || '').trim();
        if (value.length > 0) return true;
        /* Tee Scrabble / „wpisz imiona”: słowa są w chipach; input bywa pusty po dodaniu tagów */
        if (controlNode.closest && controlNode.closest('.tee-scrabble-wrapper')) {
          var scrabbleWrap = controlNode.closest('.tee-scrabble-wrapper');
          var chipNodes = scrabbleWrap.querySelectorAll('.tee-scrabble__word');
          for (var chipIndex = 0; chipIndex < chipNodes.length; chipIndex++) {
            if (String(chipNodes[chipIndex].textContent || '').trim()) return true;
          }
        }
        return false;
      }

      function getStepVisibilityToggleControl(stepNode) {
        if (!stepNode || !stepNode.querySelector) return null;
        return stepNode.querySelector(
          '.tp-step-visibility-toggle input[type="checkbox"], .tee-toggle-wrapper.tee-visibility-control input[type="checkbox"], .tp-step-visibility-toggle [role="switch"], .tee-toggle-wrapper.tee-visibility-control [role="switch"]'
        );
      }

      function isTextVisibilityHideLabelKey(labelKey) {
        if (!labelKey) return false;
        if (labelKey === 'ukryj-tekst' || labelKey.indexOf('ukryj-tekst') === 0) return true;
        if (labelKey.indexOf('ukryj') !== -1 && labelKey.indexOf('tekst') !== -1) return true;
        if (labelKey === 'bez-tekstu' || labelKey.indexOf('bez-tekstu') === 0) return true;
        if (labelKey === 'hide-text' || labelKey.indexOf('hide-text') === 0) return true;
        return labelKey === 'ukryj' || labelKey === 'hide';
      }

      function isTextVisibilityShowLabelKey(labelKey) {
        if (!labelKey) return false;
        if (labelKey === 'dodaj-tekst' || labelKey.indexOf('dodaj-tekst') === 0) return true;
        if (labelKey.indexOf('dodaj') !== -1 && labelKey.indexOf('tekst') !== -1) return true;
        if (labelKey === 'show-text' || labelKey.indexOf('show-text') === 0) return true;
        return labelKey === 'dodaj' || labelKey === 'pokaz' || labelKey === 'show';
      }

      function isTextVisibilityChoiceLabelKey(labelKey) {
        return isTextVisibilityHideLabelKey(labelKey) || isTextVisibilityShowLabelKey(labelKey);
      }

      function rememberTextVisibilityChoice(stepNode, labelNode) {
        if (!stepNode || !labelNode) return;
        var labelKey = slugifyStepKey(String(labelNode.textContent || ''));
        if (isTextVisibilityHideLabelKey(labelKey)) {
          stepNode.dataset.tpTextVisibilityMode = 'hide';
          return;
        }
        if (isTextVisibilityShowLabelKey(labelKey)) {
          stepNode.dataset.tpTextVisibilityMode = 'show';
        }
      }

      function isTextVisibilityChoiceLabelNode(labelNode) {
        if (!labelNode) return false;
        return isTextVisibilityChoiceLabelKey(slugifyStepKey(String(labelNode.textContent || '')));
      }

      function isTextVisibilityChoiceSelected(labelNode, stepNode) {
        if (!labelNode) return false;
        var radioInput = null;
        if (labelNode.htmlFor && stepNode) {
          radioInput = stepNode.querySelector('#' + labelNode.htmlFor);
        }
        if (!radioInput) radioInput = labelNode.querySelector('input[type="radio"]');
        if (!radioInput) {
          var radioWrap = labelNode.closest('.tee-radio');
          if (radioWrap) radioInput = radioWrap.querySelector('input[type="radio"]');
        }
        if (radioInput && radioInput.checked) return true;
        if (radioInput && radioInput.closest && radioInput.closest('.tee-radio.active')) return true;
        if (labelNode.classList.contains('is-selected') || labelNode.classList.contains('active')) return true;
        if (labelNode.closest && labelNode.closest('.tee-radio.active')) return true;
        if (String(labelNode.getAttribute('aria-checked') || '').toLowerCase() === 'true') return true;
        /* tee-clipart-bubble--enable tylko dla etykiet Dodaj/Ukryj (nie kafelków czcionek). */
        if (labelNode.classList.contains('tee-clipart-bubble--enable') && isTextVisibilityChoiceLabelNode(labelNode)) {
          return true;
        }
        return false;
      }

      function getTextVisibilityRadioNodes(stepNode) {
        if (!stepNode || !stepNode.querySelectorAll) return [];
        var radioNodes = [];
        stepNode.querySelectorAll('input[type="radio"]').forEach(function(radioNode) {
          if (!radioNode || radioNode.disabled) return;
          var labelNode = radioNode.id
            ? stepNode.querySelector('label[for="' + radioNode.id + '"]')
            : null;
          if (!labelNode) labelNode = radioNode.closest('label');
          var labelKey = slugifyStepKey(
            (labelNode ? labelNode.textContent : '') + ' ' + String(radioNode.value || '')
          );
          if (isTextVisibilityChoiceLabelKey(labelKey)) {
            radioNodes.push(radioNode);
          }
        });
        return radioNodes;
      }

      function getTextVisibilityChoiceFromLabels(stepNode) {
        if (!stepNode || !stepNode.querySelectorAll) return null;
        var hideSelected = false;
        var showSelected = false;
        stepNode.querySelectorAll(
          '.tee-visibility-control .tee-radio-label, .tp-step-visibility-toggle .tee-radio-label, .tee-field__header .tee-radio-label'
        ).forEach(function(labelNode) {
          if (!isTextVisibilityChoiceLabelNode(labelNode)) return;
          if (!isTextVisibilityChoiceSelected(labelNode, stepNode)) return;
          var labelKey = slugifyStepKey(String(labelNode.textContent || ''));
          if (isTextVisibilityHideLabelKey(labelKey)) hideSelected = true;
          if (isTextVisibilityShowLabelKey(labelKey)) showSelected = true;
        });
        if (showSelected) return true;
        if (hideSelected) return false;
        return null;
      }

      function getTextVisibilityRadioState(stepNode) {
        var radioNodes = getTextVisibilityRadioNodes(stepNode);
        if (!radioNodes.length) return null;

        var hideRadio = null;
        var showRadio = null;
        var radioIndex;

        for (radioIndex = 0; radioIndex < radioNodes.length; radioIndex += 1) {
          var radioNode = radioNodes[radioIndex];
          if (!radioNode || radioNode.disabled) continue;

          var labelNode = null;
          if (radioNode.id) {
            labelNode = stepNode.querySelector('label[for="' + radioNode.id + '"]');
          }
          if (!labelNode) {
            labelNode = radioNode.closest('label');
          }

          var labelKey = slugifyStepKey(
            (labelNode ? labelNode.textContent : '') + ' ' + String(radioNode.value || '')
          );
          if (!labelKey) continue;

          if (isTextVisibilityHideLabelKey(labelKey)) {
            hideRadio = radioNode;
            continue;
          }
          if (isTextVisibilityShowLabelKey(labelKey)) {
            showRadio = radioNode;
          }
        }

        if (showRadio && showRadio.checked) return true;
        if (hideRadio && hideRadio.checked) return false;
        return null;
      }

      function getStepVisibilityToggleState(stepNode) {
        var storedMode = stepNode && stepNode.dataset ? String(stepNode.dataset.tpTextVisibilityMode || '') : '';
        if (storedMode === 'hide') return false;
        if (storedMode === 'show') return true;

        var radioState = getTextVisibilityRadioState(stepNode);
        if (radioState !== null) {
          if (stepNode && stepNode.dataset) {
            stepNode.dataset.tpTextVisibilityMode = radioState === false ? 'hide' : 'show';
          }
          return radioState;
        }

        var labelState = getTextVisibilityChoiceFromLabels(stepNode);
        if (labelState !== null) {
          if (stepNode && stepNode.dataset) {
            stepNode.dataset.tpTextVisibilityMode = labelState === false ? 'hide' : 'show';
          }
          return labelState;
        }

        var toggleControl = getStepVisibilityToggleControl(stepNode);
        if (toggleControl) {
          if (typeof toggleControl.checked === 'boolean') {
            return !!toggleControl.checked;
          }
          var ariaChecked = String(toggleControl.getAttribute('aria-checked') || '').toLowerCase();
          if (ariaChecked === 'true') return true;
          if (ariaChecked === 'false') return false;
        }

        var toggleWrapper = stepNode && stepNode.querySelector
          ? stepNode.querySelector('.tp-step-visibility-toggle, .tee-toggle-wrapper.tee-visibility-control')
          : null;
        if (!toggleWrapper) return null;

        var wrapperAriaChecked = String(toggleWrapper.getAttribute('aria-checked') || '').toLowerCase();
        if (wrapperAriaChecked === 'true') return true;
        if (wrapperAriaChecked === 'false') return false;

        return null;
      }

      function isTextStepDefaultHidden(stepNode) {
        if (!stepNode || !stepNode.classList || !stepNode.classList.contains('tee-field--text')) return false;
        if (!stepNode.dataset) return false;

        if (stepNode.dataset.tpTextDefaultHiddenCaptured !== '1') {
          var initialToggleState = getStepVisibilityToggleState(stepNode);
          stepNode.dataset.tpTextDefaultHidden = initialToggleState === false ? '1' : '0';
          stepNode.dataset.tpTextDefaultHiddenCaptured = '1';
        }

        return stepNode.dataset.tpTextDefaultHidden === '1';
      }

      function formHasUploadedPhoto(formNode) {
        if (!formNode || !formNode.querySelector) return true;
        var photoStep = formNode.querySelector('.tee-field--photo, .tee-photo');
        if (!photoStep) return true;
        
        var hasUploaded = !!photoStep.querySelector('.tee-photo-label .tee-photo-uploaded, .tee-photo-uploaded');
        if (!hasUploaded) {
          hasUploaded = !!photoStep.querySelector('.tee-photo.tp-tee-photo-uploaded, .tp-tee-photo-uploaded');
        }
        if (!hasUploaded) {
          var img = photoStep.querySelector('img.tee-photo-image, .tee-photo-uploaded img, .tee-photo img');
          if (img && img.src && (img.src.indexOf('http') === 0 || img.src.indexOf('blob') === 0 || img.src.indexOf('//') === 0)) {
            hasUploaded = true;
          }
        }
        if (!hasUploaded && photoStep.querySelector('.tee-photo-clear, button[class*="clear"]')) {
          hasUploaded = true;
        }
        return hasUploaded;
      }

      function getTouchedStepRegistry(formNode) {
        if (!formNode) return null;
        /* Rejestr na sectionRoot (nie formNode) — przetrwa podmianę DOM przez TeeInBlue.
           Analogicznie do getStepExpandLockRegistry(). */
        var storeHost =
          sectionRoot && sectionRoot.contains(formNode)
            ? sectionRoot
            : formNode.closest && formNode.closest('[id^="MainProduct-"]')
              ? formNode.closest('[id^="MainProduct-"]')
              : formNode;
        if (!storeHost.__tpGuidedTouchedStepIds) {
          storeHost.__tpGuidedTouchedStepIds = {};
        }
        return storeHost.__tpGuidedTouchedStepIds;
      }

      /** Klucz blokady rozwinięcia: preferuj stabilny ID (etykieta / klasa Tee), żeby przetrwał podmianę DOM. */
      function getStepExpandLockKey(stepNode) {
        if (!stepNode) return '';
        return getStableStepId(stepNode) || ensureStepId(stepNode);
      }

      /**
       * Po pierwszym uznaniu kroku za kompletny — zawsze trzymaj go rozwinięty.
       * Trzymamy rejestr na sekcji PDP (nie na węźle formularza): Teeinblue podmienia .tee-customize-main-form
       * i nowy form traciłby __tpGuidedStepExpandLockIds — wtedy zielone kroki znów się zwijały.
       */
      function getStepExpandLockRegistry(formNode) {
        if (!formNode) return null;
        var storeHost =
          sectionRoot && sectionRoot.contains(formNode)
            ? sectionRoot
            : formNode.closest && formNode.closest('[id^="MainProduct-"]')
              ? formNode.closest('[id^="MainProduct-"]')
              : formNode;
        if (!storeHost.__tpGuidedStepExpandLockIds) {
          storeHost.__tpGuidedStepExpandLockIds = {};
        }
        return storeHost.__tpGuidedStepExpandLockIds;
      }

      function markStepTouched(stepNode) {
        if (!stepNode || !stepNode.dataset) return;
        var stepId = ensureStepId(stepNode);
        stepNode.dataset.tpGuidedTouched = '1';
        var formNode = getTeeFormNode(stepNode);
        var touchedStepRegistry = getTouchedStepRegistry(formNode);
        if (touchedStepRegistry && stepId) {
          touchedStepRegistry[stepId] = true;
        }
      }

      function isStepTouched(stepNode) {
        if (!stepNode) return false;
        if (stepNode.dataset && stepNode.dataset.tpGuidedTouched === '1') return true;
        var formNode = getTeeFormNode(stepNode);
        var stepId = ensureStepId(stepNode);
        var touchedStepRegistry = getTouchedStepRegistry(formNode);
        return !!(touchedStepRegistry && stepId && touchedStepRegistry[stepId]);
      }

      function requiresExplicitOptionChoice(stepNode) {
        return !!(stepNode && stepNode.classList && stepNode.classList.contains('tee-option'));
      }

      /** Czy krok ma pola do wypełnienia (bez tego opcjonalny krok nie jest „ukończony” zanim użytkownik go nie dotknie). */
      function stepHasInteractiveContent(stepNode) {
        if (!stepNode || !stepNode.querySelectorAll) return false;
        if (stepNode.querySelector('.tee-photo-btn, .tee-upload-btn, input[type="file"]')) return true;
        var controls = stepNode.querySelectorAll('input, textarea, select');
        var idx;
        for (idx = 0; idx < controls.length; idx += 1) {
          var control = controls[idx];
          if (!control || control.disabled) continue;
          var controlType = String(control.type || '').toLowerCase();
          if (controlType === 'hidden' || controlType === 'button' || controlType === 'submit' || controlType === 'reset') {
            continue;
          }
          if (control.closest('.tee-toggle-wrapper, .tee-visibility-control, .tp-step-visibility-toggle')) {
            continue;
          }
          if (getOwningStepForControl(control) !== stepNode) continue;
          return true;
        }
        return false;
      }

      function isDeferredTextVisibilityStep(stepNode) {
        if (!stepNode || !stepNode.classList) return false;
        if (!stepNode.classList.contains('tee-field') && !stepNode.classList.contains('tee-option')) return false;
        if (stepNode.classList.contains('tee-field--text')) return false;

        var labelKey = slugifyStepKey(getStepLabel(stepNode));
        var hasVisibilityToggle = !!getStepVisibilityToggleControl(stepNode);
        var classNameText = Array.from(stepNode.classList || []).join(' ').toLowerCase();

        if (labelKey && isTextFieldStepLabel(labelKey)) {
          return true;
        }

        if (!hasVisibilityToggle) return false;
        if (labelKey && labelKey.indexOf('tekst') !== -1) return true;
        if (classNameText.indexOf('text') !== -1 || classNameText.indexOf('tekst') !== -1) return true;
        return false;
      }

      /**
       * TeeinBlue „wyszukaj piosenkę” / Spotify: wybór zapisuje się w hidden lub w wierszu z okładką,
       * a pole wyszukiwania może zostać puste — wtedy stara logika tekstowa nigdy nie ustawiała is-complete.
       */
      function isSongSearchStep(stepNode) {
        if (!stepNode) return false;
        var label = getStepLabel(stepNode);
        var low = String(label || '').toLowerCase();
        var slug = slugifyStepKey(label);
        if (low.indexOf('piosenk') !== -1 && low.indexOf('wyszuk') !== -1) return true;
        if (slug.indexOf('piosenk') !== -1 && slug.indexOf('wyszuk') !== -1) return true;
        if (low.indexOf('song') !== -1 && (low.indexOf('search') !== -1 || low.indexOf('find') !== -1)) return true;
        return false;
      }

      function stepHasSongPickEvidence(stepNode) {
        if (!stepNode || !stepNode.querySelector) return false;
        var i, el, val, nm;
        var hiddens = stepNode.querySelectorAll('input[type="hidden"]');
        for (i = 0; i < hiddens.length; i++) {
          el = hiddens[i];
          val = String(el.value || '').trim();
          if (!val) continue;
          nm = String((el.name || '') + ' ' + (el.id || '')).toLowerCase();
          if (
            nm.indexOf('song') !== -1 ||
            nm.indexOf('track') !== -1 ||
            nm.indexOf('spotify') !== -1 ||
            nm.indexOf('music') !== -1 ||
            nm.indexOf('uri') !== -1 ||
            nm.indexOf('isrc') !== -1
          ) {
            return true;
          }
          if (/spotify\s*:/i.test(val) || val.indexOf('spotify:track:') !== -1 || val.indexOf('spotify:album:') !== -1) {
            return true;
          }
        }
        if (stepNode.querySelector('img[src*="scdn.co"], img[src*="spotify"], img[src*="i.scdn.co"]')) {
          return true;
        }
        if (
          stepNode.querySelector(
            '[data-track-id], [data-spotify-id], [data-song-id], .tee-spotify-track, .tee-song__list-item--selected, [class*="song"][class*="selected"]'
          )
        ) {
          return true;
        }
        return false;
      }

      /** Cliparty / warstwy Tee z grupami radio bez .tee-asterisk — uznaj za niekompletne, dopóki nie wybrano opcji. */
      function radioGroupsInStepHaveSelection(stepNode) {
        if (!stepNode || !stepNode.querySelectorAll) return true;
        var radios = stepNode.querySelectorAll('input[type="radio"]');
        if (!radios.length) return true;
        var groupStats = Object.create(null);
        var idx;
        var rad;
        var groupName;
        for (idx = 0; idx < radios.length; idx++) {
          rad = radios[idx];
          if (!rad || rad.disabled) continue;
          if (getOwningStepForControl(rad) !== stepNode) continue;
          groupName = String(rad.name || '');
          if (!groupName) continue;
          if (!groupStats[groupName]) {
            groupStats[groupName] = { total: 0, checked: 0 };
          }
          groupStats[groupName].total += 1;
          if (rad.checked) {
            groupStats[groupName].checked += 1;
          }
        }
        for (groupName in groupStats) {
          if (!Object.prototype.hasOwnProperty.call(groupStats, groupName)) continue;
          var stats = groupStats[groupName];
          if (stats.total > 0 && stats.checked === 0) {
            return false;
          }
        }
        return true;
      }

      /* Krok 1/2 (kolor/rozmiar) po odświeżeniu: wariant jest zachowany (radio
         zaznaczone), ale „touched" pamiętany w RAM ginie, więc krok świecił się
         jako oczekujący i trzeba było klikać go ręcznie. Jeśli aktualnie zaznaczona
         wartość zgadza się z zapisanym wcześniej wyborem użytkownika
         (localStorage „tapanda_tee_options_v1", zapis: snippets/tapanda-option-persist.liquid),
         traktujemy krok jako świadomie wybrany = ukończony. */
      function hasSavedOptionSelection(stepNode) {
        try {
          var checked = stepNode.querySelector('input[type="radio"]:checked');
          if (!checked || !checked.name || !/^(color|size)-\d+$/.test(checked.name)) return false;
          var map = JSON.parse(localStorage.getItem('tapanda_tee_options_v1') || '{}');
          return map[checked.name] === checked.value;
        } catch (e) {
          return false;
        }
      }

      function isStepComplete(stepNode) {
        if (!stepNode) return false;
        if (stepNode.classList.contains('tp-birthday-age') || stepNode.querySelector('input.tp-birthday-age[type="number"]')) {
          var birthdayAgeInput = stepNode.querySelector('input[type="number"]');
          return !!(birthdayAgeInput && !birthdayAgeInput.disabled && /^[1-9]\d?$/.test(birthdayAgeInput.value));
        }

        /* Krok „Chcesz dodać własne zmiany?" jest opcjonalny (domyślnie „Nie") i bywa ukryty
           do 3. wgrania zdjęcia — nigdy nie może blokować dalszego wypełniania formularza. */
        if (isCustomChangesStep(stepNode)) return true;

        if (stepNode.dataset && stepNode.dataset.tpTextMerged === '1') {
          return isMergedTextStepComplete(stepNode);
        }

        if (stepLooksLikeFontPicker(stepNode)) {
          return stepHasFontPickerSelection(stepNode);
        }

        if (isSongSearchStep(stepNode) && stepHasSongPickEvidence(stepNode)) {
          return true;
        }

        if (isDeferredTextVisibilityStep(stepNode)) {
          /* Przed uploadem zdjęcia — krok nie jest ukończony, tylko oczekujący. */
          if (!formHasUploadedPhoto(getTeeFormNode(stepNode))) return false;
          return isStepTouched(stepNode);
        }

        if (stepNode.classList.contains('tee-option')) {
          var requiresTouch = requiresExplicitOptionChoice(stepNode);
          /* Krok z czcionkami (Wybierz czcionkę) — TeeInBlue domyślnie zaznacza pierwszą opcję,
             a Vue przechwytuje zdarzenia kliknięcia, więc 'touch' może się nie zarejestrować.
             Jeśli radio jest zaznaczone, uznajemy krok za ukończony. */
          var isFontStep = stepLooksLikeFontPicker(stepNode);
          var radioOptions = stepNode.querySelectorAll('input[type="radio"]');
          if (radioOptions.length) {
            var hasCheckedRadio = !!stepNode.querySelector('input[type="radio"]:checked');
            if (!hasCheckedRadio) return false;
            /* Domyślny pierwszy radiobutton Tee ≠ wybór użytkownika — dopóki brak interakcji, krok nie jest „ukończony".
               Wyjątek: krok z czcionkami — TeeInBlue obsługuje go przez Vue, touch nie zawsze rejestruje się poprawnie. */
            if (requiresTouch && !isFontStep && !isStepTouched(stepNode) && !hasSavedOptionSelection(stepNode)) return false;
            return true;
          }

          var checkboxOptions = stepNode.querySelectorAll('input[type="checkbox"]');
          if (checkboxOptions.length) {
            var hasCheckedCheckbox = !!stepNode.querySelector('input[type="checkbox"]:checked');
            if (!hasCheckedCheckbox) return false;
            if (requiresTouch && !isStepTouched(stepNode)) return false;
            return true;
          }

          var selectOptions = stepNode.querySelectorAll('select');
          if (selectOptions.length) {
            var allSelected = true;
            selectOptions.forEach(function(selectNode) {
              if (!isControlFilled(selectNode)) allSelected = false;
            });
            if (!allSelected) return false;
            if (requiresTouch && !isStepTouched(stepNode)) return false;
            return true;
          }

          var fileInputs = stepNode.querySelectorAll('input[type="file"], .tee-photo-btn, .tee-upload-btn');
          if (fileInputs.length) {
            var hasUploaded = !!stepNode.querySelector('.tee-photo-label .tee-photo-uploaded, .tee-photo-uploaded, .tp-tee-photo-uploaded');
            if (!hasUploaded) return false;
          }

          var textSubControls = stepNode.querySelectorAll('input[type="text"], textarea');
          if (textSubControls.length) {
            var hasFilledText = Array.from(textSubControls).some(function(c) {
              return isControlFilled(c);
            });
            if (!hasFilledText) return false;
          }

          return true;
        }

        if (stepNode.classList.contains('tee-field--text')) {
          if (isTextStepDefaultHidden(stepNode)) {
            var toggleState = getStepVisibilityToggleState(stepNode);
            if (toggleState === false) {
              return formHasUploadedPhoto(getTeeFormNode(stepNode));
            }
          }

          var textControls = Array.from(stepNode.querySelectorAll('input[type="text"], textarea')).filter(function(controlNode) {
            if (!controlNode || controlNode.disabled) return false;
            var controlType = String(controlNode.type || '').toLowerCase();
            return controlType !== 'hidden';
          });
          if (textControls.length) {
            var hasFilledText = textControls.some(function(controlNode) {
              return isControlFilled(controlNode);
            });
            if (!hasFilledText) return false;
            return true;
          }
        }

        if (stepNode.classList.contains('tee-field--photo')) {
          var hasUploadedPhoto = !!stepNode.querySelector('.tee-photo-label .tee-photo-uploaded, .tee-photo-uploaded');
          if (!hasUploadedPhoto) {
            hasUploadedPhoto = !!stepNode.querySelector('.tee-photo.tp-tee-photo-uploaded, .tp-tee-photo-uploaded');
          }
          if (hasUploadedPhoto) return true;
          return false;
        }

        var isRequired = !!stepNode.querySelector('.tee-asterisk');
        if (!isRequired) {
          /* Tee często nie dokłada gwiazdki do warstw (np. moon_phase / data), mimo że pole jest obowiązkowe w UX. */
          var dateLikeInputs = stepNode.querySelectorAll(
            'input[type="date"], input[type="datetime-local"], input[type="time"], input[type="month"]'
          );
          for (var dateLikeIndex = 0; dateLikeIndex < dateLikeInputs.length; dateLikeIndex++) {
            var dateLikeNode = dateLikeInputs[dateLikeIndex];
            if (!dateLikeNode || dateLikeNode.disabled) continue;
            if (getOwningStepForControl(dateLikeNode) !== stepNode) continue;
            if (!isControlFilled(dateLikeNode)) return false;
          }
          if (!radioGroupsInStepHaveSelection(stepNode)) return false;
          if (stepHasInteractiveContent(stepNode) && !isStepTouched(stepNode)) {
            if (stepLooksLikeFontPicker(stepNode) && stepHasFontPickerSelection(stepNode)) {
              return true;
            }
            return false;
          }
          return true;
        }

        var controls = Array.from(stepNode.querySelectorAll('input, textarea, select')).filter(function(controlNode) {
          if (!controlNode || controlNode.disabled) return false;
          var type = String(controlNode.type || '').toLowerCase();
          if (type === 'hidden' || type === 'button' || type === 'submit' || type === 'reset') return false;
          return getOwningStepForControl(controlNode) === stepNode;
        });

        if (!controls.length) return true;

        var checkedRadioGroups = {};
        for (var index = 0; index < controls.length; index += 1) {
          var control = controls[index];
          var controlType = String(control.type || '').toLowerCase();
          if (controlType === 'radio') {
            var groupName = String(control.name || '__ungrouped__');
            if (checkedRadioGroups[groupName]) continue;
            checkedRadioGroups[groupName] = true;
            var groupHasChecked = false;
            var radioGroupNodes = stepNode.querySelectorAll('input[type="radio"]');
            for (var radioIndex = 0; radioIndex < radioGroupNodes.length; radioIndex += 1) {
              var radioNode = radioGroupNodes[radioIndex];
              if (String(radioNode.name || '__ungrouped__') !== groupName) continue;
              if (radioNode.checked) {
                groupHasChecked = true;
                break;
              }
            }
            if (!groupHasChecked) return false;
            continue;
          }
          if (controlType === 'checkbox') {
            var isVisibilityToggle = !!(
              control.closest &&
              control.closest('.tee-toggle-wrapper, .tee-switch, .tee-visibility-control, .tp-step-visibility-toggle')
            );
            if (!control.required && isVisibilityToggle) {
              continue;
            }
            if (!control.required) {
              continue;
            }
            if (!control.checked) return false;
            continue;
          }
          if (!isControlFilled(control)) return false;
        }

        return true;
      }

      /* Przy wysyłaniu formularza ufamy natywnemu `checked` dla koloru i rozmiaru.
         TeeInBlue zaznacza domyślną opcję i przekazuje ją w FormData, choć nie zawsze
         powstaje flaga ręcznego dotknięcia używana wyłącznie przez prowadzenie kroków. */
      function isStepCompleteForSubmission(stepNode) {
        if (isStepComplete(stepNode)) return true;
        if (
          !stepNode ||
          !stepNode.matches ||
          !stepNode.matches('.tee-option--color, .tee-option--size')
        ) {
          return false;
        }
        return radioGroupsInStepHaveSelection(stepNode);
      }

      /** true = zwijaj nieaktywne / niewypełnione kroki (treść przez setStepExpanded). */
      function shouldCollapseGuidedSteps() {
        return true;
      }

      function setStepExpanded(stepNode, isExpanded) {
        if (!stepNode) return;

        /* Scalony krok tekstowy: nagłówek + toggle zawsze widoczne; pola steruje Dodaj/Ukryj (CSS). */
        if (stepNode.dataset && stepNode.dataset.tpTextMerged === '1') {
          guardMergedTextStepShell(stepNode);
          ensureTextVisibilityControlsInHeader(stepNode);
          var mergedExpanded = shouldCollapseGuidedSteps() ? !!isExpanded : true;
          var mergedCollapsed = shouldCollapseGuidedSteps() ? !mergedExpanded : false;
          stepNode.classList.toggle('is-expanded', mergedExpanded);
          stepNode.classList.toggle('is-collapsed', mergedCollapsed);
          var mergedHeader = getStepHeader(stepNode);
          if (mergedHeader) {
            mergedHeader.setAttribute('aria-expanded', mergedExpanded ? 'true' : 'false');
          }
          getStepBodyNodes(stepNode).forEach(function(bodyNode) {
            bodyNode.setAttribute('data-tp-guided-body', '1');
            if (mergedCollapsed) {
              bodyNode.hidden = true;
              bodyNode.style.setProperty('display', 'none', 'important');
              return;
            }
            bodyNode.hidden = false;
            bodyNode.style.removeProperty('display');
            bodyNode.style.removeProperty('max-height');
            bodyNode.style.removeProperty('opacity');
            bodyNode.style.removeProperty('visibility');
          });
          syncTextStepInputVisibility(stepNode);
          return;
        }

        var expanded = shouldCollapseGuidedSteps() ? !!isExpanded : true;
        var isCollapsed = shouldCollapseGuidedSteps() ? !expanded : false;

        var classAlreadyCorrect = stepNode.classList.contains('is-expanded') === expanded
          && stepNode.classList.contains('is-collapsed') === isCollapsed;

        if (!classAlreadyCorrect) {
          stepNode.classList.toggle('is-expanded', expanded);
          stepNode.classList.toggle('is-collapsed', isCollapsed);
        }

        var headerNode = getStepHeader(stepNode);
        if (headerNode) {
          headerNode.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }

        /* Zawsze synchronizuj treść kroku z żądanym stanem. Wcześniejszy „early return” przy
           niezmienionych klasach zostawiał display:none na body po przebudowie TeeinBlue —
           wtedy krok był zielony (is-complete), ale treść pozostawała zwinięta. */
        getStepBodyNodes(stepNode).forEach(function(bodyNode) {
          bodyNode.setAttribute('data-tp-guided-body', '1');
          bodyNode.hidden = isCollapsed;
          if (isCollapsed) {
            bodyNode.style.setProperty('display', 'none', 'important');
          } else {
            bodyNode.style.removeProperty('display');
          }
        });

        if (!isCollapsed && stepHasTextVisibilityControls(stepNode)) {
          syncTextStepInputVisibility(stepNode);
        }
      }

      function maybeScrollToActiveStep(stepNode, shouldScroll) {
        if (!shouldScroll || !stepNode || !stepNode.getBoundingClientRect) return;
        var scrollFormNode = getTeeFormNode(stepNode);
        if (scrollFormNode && scrollFormNode.__tpSkipGuidedScrollOnce) {
          scrollFormNode.__tpSkipGuidedScrollOnce = false;
          return;
        }
        if (!window.matchMedia || !window.matchMedia('(max-width: 989px)').matches) return;

        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        if (!viewportHeight) return;

        var scrollTarget = stepNode.querySelector('.tee-field__header, .tee-option__title') || stepNode;
        var rect = scrollTarget.getBoundingClientRect();
        var stepHeight = Math.max(rect.height, scrollTarget.offsetHeight || 0);
        /* Na mobile galeria zostaje na wierzchu — przewijamy tak, by krok był ~w środku widoku, nie przy samej górze. */
        var stickyGalleryBias = window.matchMedia('(max-width: 749px)').matches
          ? viewportHeight * 0.22
          : viewportHeight * 0.08;
        var desiredTop = (viewportHeight - stepHeight) * 0.5 + stickyGalleryBias;
        var delta = rect.top - desiredTop;

        if (Math.abs(delta) < 36) return;

        window.scrollTo({
          top: Math.max(0, window.pageYOffset + delta),
          behavior: 'smooth'
        });
      }

      function syncPhotoAwaitingState(formNode) {
        if (!formNode) return;
        formNode.classList.toggle('tp-awaiting-photo', !formHasUploadedPhoto(formNode));
        guardTextCustomizationSteps(formNode);
      }

      function syncFormGuidedState(formNode, advanceFromStepNode) {
        if (!formNode) return;
        if (advanceFromStepNode) {
          trimCreatorTextFields(advanceFromStepNode);
        }
        syncPhotoAwaitingState(formNode);
        normalizeTeeinblueOptionTitles(formNode);
        syncTeeinblueColorSwatches(formNode);
        var steps = getStepNodes(formNode);
        if (!steps.length) return;

        var touchedStepRegistry = getTouchedStepRegistry(formNode);

        steps.forEach(function(stepNode, index) {
          var stepId = ensureStepId(stepNode);
          if (touchedStepRegistry && touchedStepRegistry[stepId]) {
            stepNode.dataset.tpGuidedTouched = '1';
          } else if (stepNode.dataset && stepNode.dataset.tpGuidedTouched) {
            delete stepNode.dataset.tpGuidedTouched;
          }
          stepNode.classList.add('tp-guided-step');
          stepNode.dataset.tpGuidedStepNumber = String(index + 1);
          stepNode.dataset.tpGuidedStepTotal = String(steps.length);
          stepNode.dataset.tpGuidedStepBadge = 'Krok ' + (index + 1);
          var headerNode = getStepHeader(stepNode);
          if (headerNode) {
            headerNode.dataset.tpGuidedStepNumber = String(index + 1);
          }
          syncStepVisibilityToggle(stepNode);
          bindStepToggle(formNode, stepNode);
          if (stepNode.dataset.tpTextMerged === '1') {
            bindMergedTextToggle(formNode, stepNode);
          }
        });

        formNode.querySelectorAll('.tp-text-step-merged-away').forEach(function(satelliteStep) {
          hideTextMergeSatellite(satelliteStep);
        });

        var completionMap = {};
        var allStepsComplete = true;
        var hasTouchedSteps = false;
        steps.forEach(function(stepNode) {
          var stepId = ensureStepId(stepNode);
          var stepTouched = isStepTouched(stepNode);
          var stepComplete = isStepComplete(stepNode);
          completionMap[stepId] = stepComplete;
          if (stepTouched) {
            hasTouchedSteps = true;
          }
          if (!stepComplete) allStepsComplete = false;
        });

        var activeStepId = formNode.dataset.tpGuidedActiveStep || '';
        var activeStep = steps.find(function(stepNode) {
          return ensureStepId(stepNode) === activeStepId;
        });

        if (formNode.dataset.tpGuidedInitialStepResolved !== '1') {
          // On initial render always open visual step 1, even if Teeinblue prefilled later steps.
          activeStep = steps[0] || activeStep;
          formNode.dataset.tpGuidedInitialStepResolved = '1';
        }

        /* Tee / merge „Treść” czasem ustawiają data-tp-guided-active-step na późny krok.
           Przed pierwszą interakcją: pierwszy faktycznie nieukończony krok (zwykle krok 1). */
        if (!hasTouchedSteps) {
          var firstIncompleteStep = null;
          var fi;
          var hasPhoto = formHasUploadedPhoto(formNode);
          for (fi = 0; fi < steps.length; fi += 1) {
            var candidateStep = steps[fi];
            if (isTextCustomizationStep(candidateStep) && !hasPhoto) {
              continue;
            }
            if (!completionMap[ensureStepId(candidateStep)]) {
              firstIncompleteStep = candidateStep;
              break;
            }
          }
          if (!firstIncompleteStep) {
            for (fi = 0; fi < steps.length; fi += 1) {
              if (!isTextCustomizationStep(steps[fi]) && !completionMap[ensureStepId(steps[fi])]) {
                firstIncompleteStep = steps[fi];
                break;
              }
            }
          }
          activeStep = firstIncompleteStep || steps[0];
        }

        if (!activeStep) {
          activeStep = steps[0];
        }

        var previousActiveStepId = formNode.dataset.tpGuidedActiveStep || '';
        var shouldAutoScrollToActive = hasTouchedSteps;
        var advanceStepId = advanceFromStepNode ? ensureStepId(advanceFromStepNode) : '';
        var currentAdvanceStep = advanceStepId
          ? steps.find(function(stepNode) {
              return ensureStepId(stepNode) === advanceStepId;
            })
          : null;
        var completedAdvanceStep = !!currentAdvanceStep && !!completionMap[advanceStepId];

        if (completedAdvanceStep && currentAdvanceStep) {
          var advanceIndex = steps.indexOf(currentAdvanceStep);
          var nextStep = null;
          var scanIndex;
          /* Najpierw kolejny krok w kolejności (różne produkty mają różną liczbę pól). */
          if (advanceIndex + 1 < steps.length) {
            var immediateNextId = ensureStepId(steps[advanceIndex + 1]);
            if (!completionMap[immediateNextId]) {
              nextStep = steps[advanceIndex + 1];
            }
          }
          if (!nextStep) {
            for (scanIndex = advanceIndex + 1; scanIndex < steps.length; scanIndex += 1) {
              if (!completionMap[ensureStepId(steps[scanIndex])]) {
                nextStep = steps[scanIndex];
                break;
              }
            }
          }
          if (!nextStep && advanceIndex + 1 < steps.length) {
            nextStep = steps[advanceIndex + 1];
          }
          if (nextStep) {
            activeStep = nextStep;
            shouldAutoScrollToActive = true;
          }
        }

        formNode.dataset.tpGuidedActiveStep = activeStep ? ensureStepId(activeStep) : '';
        syncPhotoAwaitingState(formNode);

        var expandLockRegistry = getStepExpandLockRegistry(formNode);
        var activeStepIndex = steps.indexOf(activeStep);

        steps.forEach(function(stepNode, stepIndex) {
          var stepId = ensureStepId(stepNode);
          var expandLockKey = getStepExpandLockKey(stepNode);
          var isComplete = !!completionMap[stepId];
          var isActive = !!activeStep && stepNode === activeStep;
          var containsActiveNestedStep = !!(
            activeStep &&
            stepNode !== activeStep &&
            stepNode.contains &&
            stepNode.contains(activeStep)
          );
          /* Ukończone kroki przed aktualnym muszą pozostać otwarte i edytowalne.
             Nie opieraj tego na globalnym hasTouchedSteps: Teeinblue potrafi odtworzyć
             zapisany wybór po przebudowie formularza bez odtworzenia tej chwilowej flagi. */
          var isCompletedPreviousStep = !!(
            isComplete &&
            activeStepIndex >= 0 &&
            stepIndex < activeStepIndex
          );
          if (
            isComplete &&
            (isStepTouched(stepNode) || isCompletedPreviousStep) &&
            expandLockRegistry &&
            expandLockKey
          ) {
            expandLockRegistry[expandLockKey] = true;
          }
          var expandLocked = !!(expandLockRegistry && expandLockKey && expandLockRegistry[expandLockKey]);
          stepNode.classList.toggle('is-complete', isComplete);
          stepNode.classList.toggle('is-active-step', isActive);
          stepNode.classList.toggle('is-pending-step', !isComplete && !isActive);
          var shouldExpandStep = isActive || containsActiveNestedStep || expandLocked;
          if (isTextCustomizationStep(stepNode) && !formHasUploadedPhoto(formNode) && !isActive) {
            shouldExpandStep = false;
          }
          setStepExpanded(stepNode, shouldExpandStep);
        });

        steps.forEach(function(stepNode) {
          if (stepNode.dataset && (stepNode.dataset.tpTextMerged === '1' || stepHasTextVisibilityControls(stepNode))) {
            syncTextStepInputVisibility(stepNode);
          }
        });

        formNode.classList.toggle('tp-guided-form-complete', allStepsComplete);

        syncGuidedProgressNode(formNode);
        var activeStepActuallyChanged = (formNode.dataset.tpGuidedActiveStep || '') !== previousActiveStepId;
        maybeScrollToActiveStep(activeStep, shouldAutoScrollToActive && activeStepActuallyChanged);
      }

      function requestSync(formNode, advanceFromStepNode) {
        if (!formNode) return;
        formNode.__tpGuidedLastInteractionAt = Date.now();
        /* Nie kasuj pending advance step pustym stringiem — „last write wins” tracił advance
           gdy requestSync(form, null) nadpisywał wcześniejsze requestSync(form, stepA). */
        if (advanceFromStepNode) {
          formNode.__tpGuidedPendingAdvanceStepId = ensureStepId(advanceFromStepNode);
        }
        if (formNode.__tpGuidedSyncTimer) {
          window.clearTimeout(formNode.__tpGuidedSyncTimer);
        }
        formNode.__tpGuidedSyncTimer = window.setTimeout(function() {
          formNode.__tpGuidedSyncTimer = null;
          var pendingAdvanceStepId = String(formNode.__tpGuidedPendingAdvanceStepId || '');
          formNode.__tpGuidedPendingAdvanceStepId = '';
          var pendingAdvanceStep = findStepNodeById(formNode, pendingAdvanceStepId);
          syncFormGuidedState(formNode, pendingAdvanceStep);
        }, 72);
      }

      function activateStep(formNode, stepNode) {
        if (!formNode || !stepNode) return;
        formNode.dataset.tpGuidedActiveStep = ensureStepId(stepNode);
        syncFormGuidedState(formNode, null);
      }

      function requestActivation(formNode, stepNode) {
        if (!formNode || !stepNode) return;
        trimCreatorTextFields(formNode);
        if (stepNode.dataset.tpGuidedStepNumber !== '1') {
          var stepNumber = parseInt(stepNode.dataset.tpGuidedStepNumber, 10);
          var allSteps = getStepNodes(formNode);
          var firstPendingStep = null;
          for (var i = 0; i < allSteps.length; i++) {
            if (!allSteps[i].classList.contains('is-complete')) {
              firstPendingStep = allSteps[i];
              break;
            }
          }
          /* Domyślna wartość Teeinblue może oznaczyć przyszły krok jako complete.
             Nadal nie pozwalaj ominąć wcześniejszego, faktycznie niewypełnionego kroku. */
          if (
            firstPendingStep &&
            firstPendingStep !== stepNode &&
            parseInt(firstPendingStep.dataset.tpGuidedStepNumber, 10) < stepNumber
          ) {
            showStepValidationError(formNode, firstPendingStep);
            return;
          }
        }
        activateStep(formNode, stepNode);
      }

      function showStepValidationError(formNode, stepNode) {
        var validationRoot = formNode || document;

        function removeDescriptionToken(controlNode, token) {
          if (!controlNode || !token) return;
          var tokens = String(controlNode.getAttribute('aria-describedby') || '')
            .split(/\s+/)
            .filter(function(candidateToken) {
              return candidateToken && candidateToken !== token;
            });
          if (tokens.length) {
            controlNode.setAttribute('aria-describedby', tokens.join(' '));
          } else {
            controlNode.removeAttribute('aria-describedby');
          }
        }

        function clearValidationTarget(controlNode) {
          if (!controlNode) return;
          var errorId = controlNode.getAttribute('data-tp-step-error-target') || '';
          removeDescriptionToken(controlNode, errorId);

          var previousInvalid = controlNode.getAttribute('data-tp-step-error-previous-invalid');
          if (previousInvalid === '__missing__') {
            controlNode.removeAttribute('aria-invalid');
          } else if (previousInvalid !== null) {
            controlNode.setAttribute('aria-invalid', previousInvalid);
          }

          if (controlNode.getAttribute('data-tp-step-error-added-tabindex') === 'true') {
            controlNode.removeAttribute('tabindex');
          }

          controlNode.removeAttribute('data-tp-step-error-target');
          controlNode.removeAttribute('data-tp-step-error-previous-invalid');
          controlNode.removeAttribute('data-tp-step-error-added-tabindex');
        }

        function markValidationTarget(controlNode, errorId) {
          if (!controlNode || !errorId) return;

          var describedBy = String(controlNode.getAttribute('aria-describedby') || '')
            .split(/\s+/)
            .filter(Boolean);
          if (describedBy.indexOf(errorId) === -1) describedBy.push(errorId);
          controlNode.setAttribute('aria-describedby', describedBy.join(' '));

          if (!controlNode.hasAttribute('data-tp-step-error-previous-invalid')) {
            controlNode.setAttribute(
              'data-tp-step-error-previous-invalid',
              controlNode.hasAttribute('aria-invalid') ? String(controlNode.getAttribute('aria-invalid')) : '__missing__'
            );
          }
          controlNode.setAttribute('aria-invalid', 'true');
          controlNode.setAttribute('data-tp-step-error-target', errorId);
        }

        function findValidationFocusTarget() {
          var candidates = stepNode.querySelectorAll(
            '.tee-btn--upload, button.tee-photo-btn, button.tee-upload-btn, .tee-photo-btn button, .tee-upload-btn button, input[type="file"], button, input, select, textarea, [tabindex]'
          );

          for (var candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
            var candidateNode = candidates[candidateIndex];
            if (!candidateNode || candidateNode.disabled || candidateNode.getAttribute('aria-hidden') === 'true') continue;
            if (!candidateNode.getClientRects || candidateNode.getClientRects().length === 0) continue;
            var candidateStyle = window.getComputedStyle ? window.getComputedStyle(candidateNode) : null;
            if (candidateStyle && (candidateStyle.visibility === 'hidden' || candidateStyle.display === 'none')) continue;
            var candidateTag = String(candidateNode.tagName || '').toLowerCase();
            var isNativelyFocusable = ['button', 'input', 'select', 'textarea'].indexOf(candidateTag) !== -1;
            if (!isNativelyFocusable && !candidateNode.hasAttribute('tabindex')) continue;
            if (typeof candidateNode.focus === 'function') return candidateNode;
          }

          var headerNode = getStepHeader(stepNode);
          if (!headerNode || typeof headerNode.focus !== 'function') return null;
          if (!headerNode.hasAttribute('tabindex')) {
            headerNode.setAttribute('tabindex', '-1');
            headerNode.setAttribute('data-tp-step-error-added-tabindex', 'true');
          }
          return headerNode;
        }

        var previousTargets = validationRoot.querySelectorAll('[data-tp-step-error-target]');
        for (var targetIndex = 0; targetIndex < previousTargets.length; targetIndex += 1) {
          clearValidationTarget(previousTargets[targetIndex]);
        }

        // Remove previous errors
        var allErrors = validationRoot.querySelectorAll('.tp-step-error-banner');
        for (var e = 0; e < allErrors.length; e++) {
          allErrors[e].parentNode.removeChild(allErrors[e]);
        }
        var allGlows = validationRoot.querySelectorAll('.tp-validation-error-glow');
        for (var g = 0; g < allGlows.length; g++) {
          allGlows[g].classList.remove('tp-validation-error-glow');
        }

        // Add persistent glow
        stepNode.classList.add('tp-validation-error-glow');

        // Create error banner ABOVE the step
        var banner = document.createElement('div');
        banner.className = 'tp-step-error-banner';
        var stepLabel = getStepLabel(stepNode) || 'ten krok';
        var errorId = 'tp-step-error-' + ensureStepId(stepNode).replace(/[^a-zA-Z0-9_-]/g, '-');
        banner.id = errorId;
        banner.setAttribute('role', 'alert');
        banner.setAttribute('aria-live', 'assertive');
        banner.setAttribute('aria-atomic', 'true');

        var iconNode = document.createElement('span');
        iconNode.className = 'tp-step-error-banner__icon';
        iconNode.setAttribute('aria-hidden', 'true');
        iconNode.textContent = '\u26A0';

        var messageNode = document.createElement('span');
        messageNode.appendChild(document.createTextNode('Najpierw wypełnij: '));
        var labelNode = document.createElement('strong');
        labelNode.textContent = stepLabel;
        messageNode.appendChild(labelNode);

        banner.appendChild(iconNode);
        banner.appendChild(document.createTextNode(' '));
        banner.appendChild(messageNode);
        stepNode.parentNode.insertBefore(banner, stepNode);

        var focusTarget = findValidationFocusTarget();
        var invalidInputs = stepNode.querySelectorAll('input[type="file"]');
        for (var inputIndex = 0; inputIndex < invalidInputs.length; inputIndex += 1) {
          markValidationTarget(invalidInputs[inputIndex], errorId);
        }
        if (focusTarget) markValidationTarget(focusTarget, errorId);

        // Activate and scroll
        activateStep(formNode, stepNode);
        var element = stepNode.querySelector('.tp-guided-step__content') || stepNode;
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (focusTarget) {
          window.requestAnimationFrame(function() {
            try {
              focusTarget.focus({ preventScroll: true });
            } catch (_error) {
              focusTarget.focus();
            }
          });
        }
        // Optional: add a bounce/shake animation class to stepNode, then remove it
        stepNode.classList.remove('tp-step-error-glow');
        void stepNode.offsetWidth; // trigger reflow
        stepNode.classList.add('tp-step-error-glow');
        setTimeout(function() {
          stepNode.classList.remove('tp-step-error-glow');
        }, 2500);

        // Remove banner when user interacts with this step
        function removeBanner() {
          if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
          var currentTargets = validationRoot.querySelectorAll('[data-tp-step-error-target="' + errorId + '"]');
          for (var currentTargetIndex = 0; currentTargetIndex < currentTargets.length; currentTargetIndex += 1) {
            clearValidationTarget(currentTargets[currentTargetIndex]);
          }
          stepNode.classList.remove('tp-validation-error-glow');
          stepNode.removeEventListener('click', removeBanner);
          stepNode.removeEventListener('change', removeBanner);
          stepNode.removeEventListener('input', removeBanner);
        }
        var isPhotoUploadStep = !!stepNode.querySelector('input[type="file"], .tee-btn--upload, .tee-photo-btn, .tee-upload-btn');
        if (!isPhotoUploadStep) {
          stepNode.addEventListener('click', removeBanner, { once: true });
        }
        stepNode.addEventListener('change', removeBanner, { once: true });
        stepNode.addEventListener('input', removeBanner, { once: true });
      }

      function bindStepToggle(formNode, stepNode) {
        var headerNode = getStepHeader(stepNode);
        if (!headerNode || headerNode.dataset.tpGuidedToggleBound === '1') return;

        /* Teeinblue renders section titles as <label> elements without a `for`
           attribute. A label cannot legally expose role="button". Replace only
           these title-only labels with a neutral element before adding the
           keyboard-operable disclosure semantics. */
        if (headerNode.tagName === 'LABEL' && !headerNode.getAttribute('for')) {
          var accessibleHeaderNode = document.createElement('div');
          Array.prototype.slice.call(headerNode.attributes).forEach(function(attributeNode) {
            accessibleHeaderNode.setAttribute(attributeNode.name, attributeNode.value);
          });
          while (headerNode.firstChild) {
            accessibleHeaderNode.appendChild(headerNode.firstChild);
          }
          headerNode.parentNode.replaceChild(accessibleHeaderNode, headerNode);
          headerNode = accessibleHeaderNode;
        }

        headerNode.dataset.tpGuidedToggleBound = '1';
        headerNode.classList.add('tp-guided-step-toggle');
        headerNode.setAttribute('role', 'button');
        if (!headerNode.hasAttribute('tabindex')) {
          headerNode.setAttribute('tabindex', '0');
        }
        headerNode.setAttribute('aria-expanded', 'false');

        function openStep() {
          requestActivation(formNode, stepNode);
        }

        function handleStepOpenRequest(event) {
          event.preventDefault();
          event.stopPropagation();
          requestActivation(formNode, stepNode);
        }

        headerNode.addEventListener('click', function(event) {
          var interactiveNode = event.target.closest(
            'a, button, input, select, textarea, label, [role="switch"], .tee-toggle-wrapper, .tee-switch, .tee-radio, .tee-radio-label, .tee-clipart, .tp-step-visibility-radios, .tp-step-visibility-toggle'
          );
          if (interactiveNode && interactiveNode !== headerNode) return;
          handleStepOpenRequest(event);
        });

        headerNode.addEventListener('keydown', function(event) {
          if (!event) return;
          var interactiveNode = event.target && event.target.closest
            ? event.target.closest('a, button, input, select, textarea, label, [role="switch"], .tee-toggle-wrapper, .tee-switch, .tee-radio, .tee-radio-label, .tee-clipart, .tp-step-visibility-radios, .tp-step-visibility-toggle')
            : null;
          if (interactiveNode && interactiveNode !== headerNode) return;
          if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
          handleStepOpenRequest(event);
        });
      }

      function bindForm(formNode) {
        if (!formNode) return;

        if (formNode.dataset.tpGuidedFormBound !== '1') {
          formNode.dataset.tpGuidedFormBound = '1';

          /* Teeinblue czasem dokleja w HTML data-tp-guided-initial-step-resolved="1"
             oraz data-tp-guided-active-step na polu uploadu. Wtedy syncFormGuidedState
             pomija gałąź „pierwszy raz → krok 1” i zostaje otwarty krok 3. Czyścimy
             raz przy pierwszym podpięciu (cold load / nowy węzeł formularza). */
          delete formNode.dataset.tpGuidedInitialStepResolved;
          delete formNode.dataset.tpGuidedActiveStep;

          formNode.addEventListener('click', function(event) {
            var targetNode = event.target;
            if (!targetNode || !targetNode.closest) return;
            var stepNode = targetNode.closest('.tp-guided-step');
            if (!stepNode || stepNode.classList.contains('is-active-step') || stepNode.classList.contains('is-complete')) return;

            var interactiveNode = targetNode.closest(
              'a, button, input, select, textarea, label, [role="switch"], .tee-toggle-wrapper, .tee-switch, .tee-radio, .tee-radio-label, .tee-clipart, .tp-step-visibility-radios, .tp-step-visibility-toggle'
            );
            if (interactiveNode) {
              window.setTimeout(function() {
                requestActivation(formNode, stepNode);
              }, 0);
              return;
            }

            event.preventDefault();
            requestActivation(formNode, stepNode);
          });

          formNode.addEventListener('input', function(event) {
            var targetNode = event.target;
            if (!targetNode || !targetNode.closest) return;
            var stepNode = targetNode.closest('.tp-guided-step');
            if (!stepNode) return;
            if (event.isTrusted === true) {
              markStepTouched(stepNode);
            }
            requestSync(formNode, null);
          });

          formNode.addEventListener('change', function(event) {
            var targetNode = event.target;
            if (!targetNode || !targetNode.closest) return;
            var stepNode = targetNode.closest('.tp-guided-step');
            if (stepNode && event.isTrusted === true) {
              markStepTouched(stepNode);
            }
            if (stepNode && stepHasTextVisibilityControls(stepNode)) {
              captureTextVisibilityModeFromDom(stepNode);
              syncTextStepInputVisibility(stepNode);
            }
            requestSync(formNode, stepNode || null);
          });

          formNode.addEventListener('click', function(event) {
            var targetNode = event.target;
            if (!targetNode || !targetNode.closest) return;
            var visibilityLabelNode = targetNode.closest('.tee-radio-label, .tee-visibility-control label');
            if (visibilityLabelNode && isTextVisibilityChoiceLabelNode(visibilityLabelNode)) {
              var visibilityStepNode = visibilityLabelNode.closest('.tp-guided-step, .tee-field, .tee-option');
              if (visibilityStepNode && formNode.contains(visibilityStepNode) && stepHasTextVisibilityControls(visibilityStepNode)) {
                rememberTextVisibilityChoice(visibilityStepNode, visibilityLabelNode);
                function runVisibilitySyncPasses() {
                  maybeApplyTextStepMerge(formNode);
                  markStepTouched(visibilityStepNode);
                  syncTextStepInputVisibility(visibilityStepNode);
                  requestSync(formNode, visibilityStepNode);
                }
                formNode.__tpSkipGuidedScrollOnce = true;
                window.setTimeout(runVisibilitySyncPasses, 0);
                window.setTimeout(function() {
                  maybeApplyTextStepMerge(formNode);
                  syncTextStepInputVisibility(visibilityStepNode);
                }, 120);
                window.setTimeout(function() {
                  maybeApplyTextStepMerge(formNode);
                  syncTextStepInputVisibility(visibilityStepNode);
                }, 320);
              }
            }
          }, true);

          formNode.addEventListener('click', function(event) {
            var targetNode = event.target;
            if (!targetNode || !targetNode.closest) return;
            var stepNode = targetNode.closest('.tp-guided-step');
            if (!stepNode) return;
            if (targetNode.closest('.tp-guided-step-toggle')) return;

            var optionInteractionNode = targetNode.closest(
              'label, .tee-radio, .tee-radio-label, .tee-swatch--color, .tee-option-inner, .tee-select-wrapper, select'
            );
            if (!optionInteractionNode) return;

            var isOptionStep = stepNode.classList.contains('tee-option');
            var isFontFieldStep = stepNode.classList.contains('tee-field') && stepLooksLikeFontPicker(stepNode);
            var isMergedHostFontPick = !!(
              stepNode.dataset &&
              stepNode.dataset.tpTextMerged === '1' &&
              targetNode.closest('.tp-merged-text-fonts .tee-radio-label')
            );
            if (!isOptionStep && !isFontFieldStep && !isMergedHostFontPick) return;

            if (event.isTrusted === true) {
              markStepTouched(stepNode);
            }
            requestSync(formNode, stepNode);
          });

          formNode.addEventListener('click', function(event) {
            var targetNode = event.target;
            if (!targetNode || !targetNode.closest) return;

            var actionNode = targetNode.closest('button, .tee-btn, [role="button"], a');
            if (!actionNode) return;

            var actionText = String(actionNode.textContent || '').toLowerCase();
            if (actionText.indexOf('zapisz') === -1 && actionText.indexOf('save') === -1) return;

            window.setTimeout(function() {
              var stepNode = actionNode.closest('.tp-guided-step') || formNode.querySelector('.tp-guided-step.is-active-step');
              if (stepNode) {
                markStepTouched(stepNode);
              }
              requestSync(formNode, stepNode || null);
            }, 80);
          });
        }

        syncFormGuidedState(formNode, null);
      }

      function refreshAllForms() {
        var sectionRoot = document.getElementById('MainProduct-' + TPMP.sectionId);
        if (sectionRoot && typeof sectionRoot.__tpMoveVariantBlocksIntoForm === 'function') {
          sectionRoot.__tpMoveVariantBlocksIntoForm();
        }
        var forms = getTeeFormNodes(document);
        if (!forms.length) return;
        /* Auto-detect TeeInBlue readiness: if form already has rendered steps, mark ready. */
        forms.forEach(function(formNode) {
          if (!formNode.__tpTibReady) {
            var hasRenderedSteps = formNode.querySelector('.tee-option, .tee-field');
            if (hasRenderedSteps) {
              formNode.__tpTibReady = true;
            }
          }
        });
        forms.forEach(bindForm);
        forms.forEach(maybeApplyTextStepMerge);
        forms.forEach(syncPhotoAwaitingState);
        bindTeeAtcValidation();
        bindTeeAtcSubmitInterceptor();
      }

      function markTeeFormsReady() {
        getTeeFormNodes(document).forEach(function(formNode) {
          formNode.__tpTibReady = true;
        });
      }

      function scheduleTextStepMergeRetries() {
        [120, 400, 900, 1800].forEach(function(delayMs) {
          window.setTimeout(function() {
            getTeeFormNodes(document).forEach(function(formNode) {
              maybeApplyTextStepMerge(formNode);
              syncPhotoAwaitingState(formNode);
            });
          }, delayMs);
        });
      }

      function onTeeinblueReady() {
        markTeeFormsReady();
        scheduleTextStepMergeRetries();
        schedulePhotoAwaitingSync();
        window.setTimeout(function() {
          scheduleRefresh(0);
        }, 120);
      }

      // --- TAPANDA: Intercept TeeinBlue ATC button for validation ---
      function getCartItemCount() {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(response) {
            if (!response || !response.ok) return null;
            return response.json();
          })
          .then(function(cartData) {
            if (!cartData || typeof cartData.item_count !== 'number') return null;
            return cartData.item_count;
          })
          .catch(function() {
            return null;
          });
      }

      function addGiftWrapVariantToCart(variantId) {
        if (!variantId) return Promise.resolve(null);

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        config.body = formData;

        return fetch(`${routes.cart_add_url}`, config)
          .then(function(response) { return response.json(); })
          .then(function(responseData) {
            if (responseData && !responseData.status && typeof window.tapandaClearGiftWrapIntent === 'function') {
              window.tapandaClearGiftWrapIntent(String(variantId));
            }
            return responseData;
          })
          .catch(function() { return null; });
      }

      function schedulePromoPopupAfterAtc(triggerNode) {
        var formNode = getTeeFormNode(triggerNode);
        var giftWrapToggle = formNode ? formNode.querySelector('[data-tp-gift-wrap-toggle]') : null;
        var shouldAddGiftWrap = !!(
          giftWrapToggle &&
          giftWrapToggle.checked &&
          giftWrapToggle.dataset.giftVariantId
        );
        var giftWrapVariantId = shouldAddGiftWrap ? String(giftWrapToggle.dataset.giftVariantId) : '';
        if (giftWrapVariantId && typeof window.tapandaRememberGiftWrapIntent === 'function') {
          window.tapandaRememberGiftWrapIntent(giftWrapVariantId);
        } else if (!giftWrapVariantId && typeof window.tapandaClearGiftWrapIntent === 'function') {
          window.tapandaClearGiftWrapIntent();
        }

        var isTeeinbluePage = !!(document.querySelector('#teeAtcButton, .tee-btn--atc, .tee-customize-main-form, form.tee-form-wrapper, [data-teeinblue]'));
        if (isTeeinbluePage) {
          if (typeof window.tapandaApplySecondProductDiscountCode === 'function') {
            window.tapandaApplySecondProductDiscountCode({ force: true });
          }
          // Teeinblue handles its own cart redirect — clear guard and allow cart nav.
          try {
            sessionStorage.setItem('tapanda-cart-redirect-guard-until', '0');
            sessionStorage.setItem('tapanda-cart-promo-open-until', '0');
            sessionStorage.setItem('tapanda-cart-redirect-allow-until', String(Date.now() + 60000));
          } catch(e) {}
          window.__tpBlockCartNavigationUntil = 0;
          if (typeof window.tapandaAllowCartNavigation === 'function') {
            window.tapandaAllowCartNavigation(60000);
          }
          return;
        } else if (typeof window.tapandaActivateCartRedirectGuard === 'function') {
          window.tapandaActivateCartRedirectGuard(15000);
        }
        var alreadyAdded = !!(
          triggerNode &&
          triggerNode.dataset &&
          triggerNode.dataset.tpAtcAlreadyAdded === '1'
        );

        function finalizePromoFlow(giftWrapAdded) {
          if (shouldAddGiftWrap && giftWrapAdded && typeof window.tapandaNavigateToCart === 'function') {
            window.tapandaNavigateToCart('teeinblue_gift_wrap_toggle');
            return;
          }
          if (typeof window.tapandaShowCartPromotionPopup === 'function') {
            window.tapandaShowCartPromotionPopup({ giftWrapSelected: shouldAddGiftWrap });
          }
        }

        function finalizeAfterGiftWrapAdd() {
          addGiftWrapVariantToCart(giftWrapVariantId)
            .then(function(giftWrapResponse) {
              finalizePromoFlow(!!(giftWrapResponse && !giftWrapResponse.status));
            })
            .catch(function() {
              finalizePromoFlow(false);
            });
        }

        if (alreadyAdded) {
          if (shouldAddGiftWrap && giftWrapVariantId) {
            finalizeAfterGiftWrapAdd();
          } else {
            finalizePromoFlow(false);
          }
          return;
        }

        var requestId = Date.now() + Math.random();
        window.__tpCartPromoRequestId = requestId;

        getCartItemCount().then(function(beforeCount) {
          if (beforeCount === null) {
            if (shouldAddGiftWrap && giftWrapVariantId) {
              finalizeAfterGiftWrapAdd();
            } else {
              window.setTimeout(function() { finalizePromoFlow(false); }, 900);
            }
            return;
          }

          var attempts = 0;
          function checkCartAfterDelay(delayMs) {
            window.setTimeout(function() {
              if (window.__tpCartPromoRequestId !== requestId) return;
              getCartItemCount().then(function(afterCount) {
                if (window.__tpCartPromoRequestId !== requestId) return;
                if (afterCount !== null && afterCount > beforeCount) {
                  if (shouldAddGiftWrap && giftWrapVariantId) {
                    finalizeAfterGiftWrapAdd();
                  } else {
                    finalizePromoFlow(false);
                  }
                  return;
                }
                attempts += 1;
                if (attempts < 4) {
                  checkCartAfterDelay(650);
                } else {
                  if (shouldAddGiftWrap && giftWrapVariantId) {
                    finalizeAfterGiftWrapAdd();
                  } else {
                    finalizePromoFlow(false);
                  }
                }
              });
            }, delayMs);
          }

          checkCartAfterDelay(900);
        });
      }

      function bindTeeAtcValidation() {
        var atcButtons = document.querySelectorAll('.tee-btn--atc, #teeAtcButton, #teeFormActions button[type="submit"], .tee-form-actions button[type="submit"]');
        atcButtons.forEach(function(btn) {
          if (btn.dataset.tpAtcValidationBound === '1') return;
          btn.dataset.tpAtcValidationBound = '1';
          btn.addEventListener('click', function(event) {
            var formNode = getTeeFormNode(btn);
            if (!formNode) return;
            trimCreatorTextFields(formNode);
            var steps = getStepNodes(formNode);
            if (steps.length) {
              var firstIncomplete = null;
              for (var i = 0; i < steps.length; i++) {
                if (!isStepCompleteForSubmission(steps[i])) {
                  firstIncomplete = steps[i];
                  break;
                }
              }
              if (firstIncomplete) {
                event.preventDefault();
                event.stopImmediatePropagation();
                showStepValidationError(formNode, firstIncomplete);
                return;
              }
            }

            var buttonType = String(btn.getAttribute('type') || 'submit').toLowerCase();
            if (buttonType !== 'submit') {
              schedulePromoPopupAfterAtc(btn);
            }
          }, true);
        });
      }

      function bindTeeAtcSubmitInterceptor() {
        var forms = getTeeFormNodes(document);
        forms.forEach(function(formNode) {
          if (!formNode || formNode.dataset.tpAtcSubmitInterceptBound === '1') return;
          formNode.dataset.tpAtcSubmitInterceptBound = '1';
          formNode.addEventListener('submit', function(event) {
            var action = String(formNode.getAttribute('action') || '').toLowerCase();
            if (!action || action.indexOf('/cart/add') === -1) return;
            trimCreatorTextFields(formNode);

            var steps = getStepNodes(formNode);
            if (steps.length) {
              var firstIncomplete = null;
              for (var i = 0; i < steps.length; i++) {
                if (!isStepCompleteForSubmission(steps[i])) {
                  firstIncomplete = steps[i];
                  break;
                }
              }
              if (firstIncomplete) {
                event.preventDefault();
                event.stopImmediatePropagation();
                showStepValidationError(formNode, firstIncomplete);
                return;
              }
            }

            var triggerNode = event.submitter || formNode;
            schedulePromoPopupAfterAtc(triggerNode);
          }, true);
        });
      }

      function getRefreshDelay() {
        var latestInteractionAt = 0;
        getTeeFormNodes(document).forEach(function(formNode) {
          latestInteractionAt = Math.max(latestInteractionAt, Number(formNode.__tpGuidedLastInteractionAt || 0));
        });
        if (latestInteractionAt && Date.now() - latestInteractionAt < 220) {
          return 140;
        }
        return 80;
      }

      function schedulePhotoAwaitingSync() {
        [0, 200, 500, 900, 1500, 2500, 4000, 6500, 10000].forEach(function(delayMs) {
          window.setTimeout(function() {
            getTeeFormNodes(document).forEach(syncPhotoAwaitingState);
          }, delayMs);
        });
      }

      function scheduleRefresh(delay) {
        var wait = typeof delay === 'number' ? delay : getRefreshDelay();
        if (refreshTimeout) {
          window.clearTimeout(refreshTimeout);
          refreshTimeout = null;
        }

        function runRefresh() {
          if (refreshFrame) {
            refreshQueued = true;
            return;
          }
          refreshFrame = window.requestAnimationFrame(function() {
            refreshFrame = null;
            if (window.__tpGuidedObserver) { window.__tpGuidedObserver.disconnect(); }
            try {
              refreshAllForms();
            } finally {
              if (window.__tpGuidedObserver && typeof sectionRoot !== 'undefined' && sectionRoot) { window.__tpGuidedObserver.observe(sectionRoot, { childList: true, subtree: true }); }
              if (refreshQueued) {
                refreshQueued = false;
                scheduleRefresh(0);
              }
            }
          });
        }

        if (wait <= 0) {
          runRefresh();
          return;
        }

        refreshTimeout = window.setTimeout(function() {
          refreshTimeout = null;
          runRefresh();
        }, wait);
      }

      function bindExternalAdvanceRequests() {
        if (sectionRoot.dataset.tpGuidedExternalAdvanceBound === '1') return;
        sectionRoot.dataset.tpGuidedExternalAdvanceBound = '1';

        sectionRoot.addEventListener('tapanda:guided-advance-step', function(event) {
          var detail = event && event.detail ? event.detail : {};
          var stepNode = detail.stepNode || null;
          if (!stepNode && detail.photoNode && detail.photoNode.closest) {
            stepNode = detail.photoNode.closest('.tp-guided-step, .tee-field--photo');
          }
          if (!stepNode || !stepNode.closest) return;

          var formNode = detail.formNode || null;
          if (!formNode && stepNode.closest) {
            formNode = getTeeFormNode(stepNode);
          }
          if (!formNode || !sectionRoot.contains(formNode)) return;

          markStepTouched(stepNode);
          syncPhotoAwaitingState(formNode);
          requestSync(formNode, stepNode);
        });
      }

      bindExternalAdvanceRequests();
      sectionRoot.__tpSyncPhotoAwaitingState = syncPhotoAwaitingState;
      window.tapandaSyncPhotoAwaitingState = syncPhotoAwaitingState;
      schedulePhotoAwaitingSync();
      scheduleRefresh(0);
      window.setTimeout(function() { scheduleRefresh(0); }, 300);
      window.setTimeout(function() { scheduleRefresh(0); }, 900);
      window.setTimeout(function() { scheduleRefresh(0); }, 1800);
      window.setTimeout(function() { scheduleRefresh(0); }, 4000);
      window.setTimeout(function() { scheduleRefresh(0); }, 8000);

      document.addEventListener('teeinblue:ready', onTeeinblueReady);
      document.addEventListener('teeinblue:product-updated', function() {
        markTeeFormsReady();
        scheduleRefresh();
      });
      window.addEventListener('tapanda:tib-ready', onTeeinblueReady);
      window.addEventListener('resize', function() { scheduleRefresh(0); });

      if (typeof MutationObserver !== 'undefined') {
        window.__tpGuidedObserver = new MutationObserver(function(records) {
          if (!mutationBatchTouchesTeeinblue(records)) return;
          scheduleRefresh();
        });
        window.__tpGuidedObserver.observe(sectionRoot, { childList: true, subtree: true });
      }
    }

    function initTeeinblueUploadProgress() {
      var sectionRoot = document.getElementById('MainProduct-' + TPMP.sectionId);
      if (!sectionRoot || sectionRoot.dataset.tpUploadProgressInit === '1') return;
      sectionRoot.dataset.tpUploadProgressInit = '1';

      /* --- Komunikaty podczas uploadu/generowania ---
         Rotujace, zachecajace napisy pokazujemy NA przycisku "Przesylanie"
         (.tee-btn--upload), a na dole (.tee-upload-instruction) zostaje statyczne
         "Przesylanie...". Zmiana napisu ma plynna animacje (fade + slide + blur). */
      var WAIT_HINTS = [
        'Wgrywamy Twoje zdjęcie',
        'AI analizuje Twoje zdjęcie',
        'Rozpoznajemy twarze i detale',
        'Dobieramy kolory i światło',
        'Tworzymy Twój unikalny podgląd',
        'Komponujemy całość w ramce',
        'Dopracowujemy każdy detal',
        'Nadajemy finalny szlif',
        'Już prawie gotowe'
      ];
      var waitHintIndex = 0;
      var waitHintTimer = null;

      function isTeeUploading() {
        return !!sectionRoot.querySelector('.tee-photo-uploading');
      }
      function uploadBtns() {
        return sectionRoot.querySelectorAll('.tee-photo .tee-btn--upload');
      }
      function btnLabelSpan(btn) {
        return btn.querySelector('span:not(.tee-loading)') || btn;
      }
      function instructionNodes() {
        return sectionRoot.querySelectorAll('.tee-upload-instruction');
      }
      function setBtnText(text) {
        uploadBtns().forEach(function(btn) {
          btn.classList.add('tp-uploading-msg');
          var span = btnLabelSpan(btn);
          if (!('tpBtnOrig' in span.dataset)) span.dataset.tpBtnOrig = span.textContent || '';
          if (span.textContent !== text) span.textContent = text;
        });
      }
      function fadeBtnText(text) {
        var btns = uploadBtns();
        if (!btns.length) return;
        btns.forEach(function(btn) {
          var span = btnLabelSpan(btn);
          span.style.transition = 'opacity .4s ease, transform .4s ease, filter .4s ease';
          span.style.opacity = '0';
          span.style.transform = 'translateY(-7px)';
          span.style.filter = 'blur(2px)';
        });
        window.setTimeout(function() {
          setBtnText(text);
          uploadBtns().forEach(function(btn) {
            var span = btnLabelSpan(btn);
            span.style.transform = 'translateY(7px)';
            void span.offsetWidth; /* reflow, by animacja wejscia zadzialala */
            span.style.opacity = '1';
            span.style.transform = 'translateY(0)';
            span.style.filter = 'blur(0)';
          });
        }, 400);
      }
      function hideInstruction() {
        instructionNodes().forEach(function(node) {
          if (!('tpWaitDisp' in node.dataset)) node.dataset.tpWaitDisp = node.style.display || '';
          node.style.display = 'none';
        });
      }
      function showInstruction() {
        instructionNodes().forEach(function(node) {
          if ('tpWaitDisp' in node.dataset) {
            node.style.display = node.dataset.tpWaitDisp;
            delete node.dataset.tpWaitDisp;
          } else {
            node.style.display = '';
          }
        });
      }
      function restoreWaitCopy() {
        uploadBtns().forEach(function(btn) {
          btn.classList.remove('tp-uploading-msg');
          var span = btnLabelSpan(btn);
          span.style.opacity = '';
          span.style.transform = '';
          span.style.transition = '';
          span.style.filter = '';
          if ('tpBtnOrig' in span.dataset && span.textContent !== span.dataset.tpBtnOrig) {
            span.textContent = span.dataset.tpBtnOrig;
          }
        });
        showInstruction();
      }
      function startWaitRotation() {
        if (waitHintTimer) return;
        waitHintIndex = 0;
        setBtnText(WAIT_HINTS[0]);
        hideInstruction();
        waitHintTimer = window.setInterval(function() {
          if (!isTeeUploading()) {
            stopWaitRotation();
            return;
          }
          waitHintIndex = (waitHintIndex + 1) % WAIT_HINTS.length;
          fadeBtnText(WAIT_HINTS[waitHintIndex]);
        }, 4500);
      }
      function stopWaitRotation() {
        if (waitHintTimer) {
          window.clearInterval(waitHintTimer);
          waitHintTimer = null;
        }
        restoreWaitCopy();
      }
      function syncWaitCopy() {
        if (isTeeUploading()) {
          startWaitRotation();
          setBtnText(WAIT_HINTS[waitHintIndex]);
          hideInstruction();
        } else {
          stopWaitRotation();
        }
      }

      function clampPercent(value) {
        var numeric = Number(value);
        if (!isFinite(numeric)) return 0;
        if (numeric < 0) return 0;
        if (numeric > 100) return 100;
        return Math.round(numeric);
      }

      var UPLOAD_HINTS = [
        'Wgrywamy Twoje zdjęcie…',
        'AI analizuje kompozycję…',
        'Dobieramy najlepsze ujęcie…',
        'Tworzymy Twój podgląd…',
        'Jeszcze chwilka — warto poczekać ✨'
      ];
      var UPLOAD_HINT_ALMOST = 'Już prawie gotowe…';
      var UPLOAD_HINT_DEFAULT = 'Przesyłanie zdjęcia';

      function setUploadLabel(state, text) {
        if (state && state.labelNode && text) state.labelNode.textContent = text;
      }

      function startHintRotation(state) {
        if (!state || !state.labelNode) return;
        if (state.hintTimer) window.clearInterval(state.hintTimer);
        state.hintIndex = 0;
        setUploadLabel(state, UPLOAD_HINTS[0]);
        state.hintTimer = window.setInterval(function() {
          if (!state.pending) return;
          if (clampPercent(state.percent) >= 88) {
            setUploadLabel(state, UPLOAD_HINT_ALMOST);
            return;
          }
          state.hintIndex = (state.hintIndex + 1) % UPLOAD_HINTS.length;
          setUploadLabel(state, UPLOAD_HINTS[state.hintIndex]);
        }, 2300);
      }

      function stopHintRotation(state) {
        if (state && state.hintTimer) {
          window.clearInterval(state.hintTimer);
          state.hintTimer = null;
        }
      }

      function createProgressNode(photoNode) {
        var existingNode = photoNode.querySelector('.tp-tee-upload-progress');
        if (existingNode) return existingNode;

        var progressNode = document.createElement('div');
        progressNode.className = 'tp-tee-upload-progress';
        progressNode.innerHTML =
          '<div class="tp-tee-upload-progress__meta">' +
          '<span class="tp-tee-upload-progress__label">Przesyłanie zdjęcia</span>' +
          '<span class="tp-tee-upload-progress__value">0%</span>' +
          '</div>' +
          '<div class="tp-tee-upload-progress__bar"><span class="tp-tee-upload-progress__fill"></span></div>';

        var instructionNode = photoNode.querySelector('.tee-upload-instruction');
        if (instructionNode && instructionNode.parentNode) {
          instructionNode.parentNode.insertBefore(progressNode, instructionNode);
        } else {
          photoNode.appendChild(progressNode);
        }
        return progressNode;
      }

      function getPhotoState(photoNode) {
        if (photoNode.__tpUploadState) return photoNode.__tpUploadState;
        var progressNode = createProgressNode(photoNode);
        var state = {
          photoNode: photoNode,
          progressNode: progressNode,
          labelNode: progressNode.querySelector('.tp-tee-upload-progress__label'),
          valueNode: progressNode.querySelector('.tp-tee-upload-progress__value'),
          fillNode: progressNode.querySelector('.tp-tee-upload-progress__fill'),
          percent: 0,
          displayPercent: 0,
          pending: false,
          fallbackTimer: null,
          hideTimer: null,
          progressAnimId: null,
          hintTimer: null,
          hintIndex: 0
        };
        photoNode.__tpUploadState = state;
        return state;
      }

      function clearTimers(state) {
        if (!state) return;
        if (state.fallbackTimer) {
          window.clearInterval(state.fallbackTimer);
          state.fallbackTimer = null;
        }
        if (state.hideTimer) {
          window.clearTimeout(state.hideTimer);
          state.hideTimer = null;
        }
        if (state.progressAnimId) {
          window.clearInterval(state.progressAnimId);
          state.progressAnimId = null;
        }
        if (state.hintTimer) {
          window.clearInterval(state.hintTimer);
          state.hintTimer = null;
        }
      }

      function syncProgressVisual(state) {
        if (!state) return;
        state.displayPercent = clampPercent(state.displayPercent);
        var shown = state.displayPercent;
        if (state.valueNode) state.valueNode.textContent = shown + '%';
        if (state.fillNode) state.fillNode.style.width = shown + '%';
      }

      function ensureProgressAnimation(state) {
        if (!state) return;
        if (typeof state.displayPercent !== 'number' || !isFinite(state.displayPercent)) {
          state.displayPercent = clampPercent(state.percent);
        }
        var target = clampPercent(state.percent);
        if (state.displayPercent === target) {
          if (state.progressAnimId) {
            window.clearInterval(state.progressAnimId);
            state.progressAnimId = null;
          }
          return;
        }
        if (state.progressAnimId) return;
        state.progressAnimId = window.setInterval(function() {
          var tgt = clampPercent(state.percent);
          if (state.displayPercent === tgt) {
            window.clearInterval(state.progressAnimId);
            state.progressAnimId = null;
            return;
          }
          if (state.displayPercent < tgt) {
            state.displayPercent = Math.min(tgt, state.displayPercent + 1);
          } else {
            state.displayPercent = Math.max(tgt, state.displayPercent - 1);
          }
          syncProgressVisual(state);
        }, 26);
      }

      function renderProgress(state, percent, labelText, isError) {
        if (!state) return;
        state.percent = clampPercent(percent);
        state.progressNode.classList.add('is-visible');
        state.progressNode.classList.toggle('is-error', !!isError);
        if (state.labelNode && labelText) state.labelNode.textContent = labelText;
        ensureProgressAnimation(state);
        syncProgressVisual(state);
      }

      function hideProgress(state) {
        if (!state) return;
        clearTimers(state);
        state.pending = false;
        state.percent = 0;
        state.displayPercent = 0;
        state.progressNode.classList.remove('is-visible', 'is-error');
        if (state.labelNode) state.labelNode.textContent = UPLOAD_HINT_DEFAULT;
        if (state.valueNode) state.valueNode.textContent = '0%';
        if (state.fillNode) state.fillNode.style.width = '0%';
      }

      function markUploadDone(state) {
        if (!state) return;
        clearTimers(state);
        state.pending = false;
        renderProgress(state, 100, 'Gotowe ✓', false);
        state.hideTimer = window.setTimeout(function() {
          hideProgress(state);
        }, 1400);
      }

      function markUploadError(state) {
        if (!state) return;
        clearTimers(state);
        state.pending = false;
        renderProgress(state, Math.max(1, state.percent || 0), 'Coś poszło nie tak', true);
        state.hideTimer = window.setTimeout(function() {
          hideProgress(state);
        }, 2600);
      }

      function startFallbackProgress(state) {
        if (!state) return;
        clearTimers(state);
        state.pending = true;
        state.displayPercent = 0;
        renderProgress(state, 0, null, false);
        startHintRotation(state);
        state.fallbackTimer = window.setInterval(function() {
          if (!state.pending) return;
          var cur = state.percent;
          var delta = cur < 38 ? 3 : cur < 72 ? 2 : 1;
          renderProgress(state, Math.min(cur + delta, 90), null, false);
        }, 165);
      }

      function requestGuidedStepAdvance(photoNode) {
        if (!photoNode || typeof CustomEvent !== 'function') return;

        var stepNode = photoNode.closest ? photoNode.closest('.tp-guided-step, .tee-field--photo') : null;
        if (!stepNode || !stepNode.closest) return;

        var formNode = getTeeFormNode(stepNode);
        if (!formNode) return;

        sectionRoot.dispatchEvent(
          new CustomEvent('tapanda:guided-advance-step', {
            bubbles: true,
            detail: {
              source: 'photo-upload-save',
              photoNode: photoNode,
              stepNode: stepNode,
              formNode: formNode
            }
          })
        );
      }

      function getBestPhotoNodeForAdvance() {
        var activeStepNode = sectionRoot.querySelector('.tp-guided-step.is-active-step');
        if (activeStepNode) {
          if (activeStepNode.classList.contains('tee-photo')) return activeStepNode;
          var nestedActivePhotoNode = activeStepNode.querySelector('.tee-photo');
          if (nestedActivePhotoNode) return nestedActivePhotoNode;
        }

        var photoNodes = sectionRoot.querySelectorAll('.tee-photo');
        for (var index = 0; index < photoNodes.length; index += 1) {
          var candidateNode = photoNodes[index];
          if (!candidateNode) continue;
          if (candidateNode.classList.contains('tp-tee-photo-uploaded')) return candidateNode;
          if (candidateNode.querySelector('.tee-photo-uploaded, .tee-photo-label .tee-photo-uploaded')) {
            return candidateNode;
          }
        }

        return null;
      }

      function bindPhotoInputs() {
        var photoNodes = sectionRoot.querySelectorAll('.tee-photo');
        photoNodes.forEach(function(photoNode, photoIndex) {
          var inputNode = photoNode.querySelector('input[type="file"]');
          if (!inputNode) return;
          var bindKey = inputNode.id || 'photo-upload-' + photoIndex;
          if (inputNode.dataset.tpUploadProgressBound === bindKey) return;
          inputNode.dataset.tpUploadProgressBound = bindKey;

          inputNode.addEventListener('change', function() {
            var state = getPhotoState(photoNode);
            photoNode.dataset.tpGuidedAdvancedOnUpload = '0';
            if (!inputNode.files || !inputNode.files.length) {
              hideProgress(state);
              return;
            }
            startFallbackProgress(state);
          });
        });
      }

      function completeOnPreviewReady() {
        var photoNodes = sectionRoot.querySelectorAll('.tee-photo');
        photoNodes.forEach(function(photoNode) {
          var state = photoNode.__tpUploadState;
          var hasUploaded = !!photoNode.querySelector('.tee-photo-uploaded, .tee-photo-label .tee-photo-uploaded');
          var isUploading = !!photoNode.querySelector('.tee-photo-uploading');

          if (!hasUploaded || isUploading) {
            if (photoNode.dataset.tpGuidedAdvancedOnUpload !== '0') {
              photoNode.dataset.tpGuidedAdvancedOnUpload = '0';
            }
            return;
          }

          if (state && state.pending) {
            markUploadDone(state);
          }

          if (photoNode.dataset.tpGuidedAdvancedOnUpload === '1') return;
          photoNode.dataset.tpGuidedAdvancedOnUpload = '1';

          requestGuidedStepAdvance(photoNode);
        });
      }

      function bindPopupSaveAdvance() {
        if (sectionRoot.dataset.tpPopupSaveAdvanceBound === '1') return;
        sectionRoot.dataset.tpPopupSaveAdvanceBound = '1';

        document.addEventListener(
          'click',
          function(event) {
            var targetNode = event.target;
            if (!targetNode || !targetNode.closest) return;

            var saveButton = targetNode.closest(
              'button.tee-btn.tee-btn--sm.tee-btn--rounded.tee-btn--primary[type="button"]'
            );
            if (!saveButton) return;

            var buttonText = String(saveButton.textContent || '').toLowerCase();
            if (buttonText.indexOf('zapisz') === -1 && buttonText.indexOf('save') === -1) return;

            /* Sync progresywnie, ale advance wyślij tylko raz po ostatnim sync.
               Spamowanie 4 advance events powodowało wyścig w requestSync() (debounce 72ms). */
            [90, 240, 520, 980].forEach(function(delayMs) {
              window.setTimeout(function() {
                scheduleProgressSync();
              }, delayMs);
            });
            window.setTimeout(function() {
              var photoNode = getBestPhotoNodeForAdvance();
              if (photoNode) requestGuidedStepAdvance(photoNode);
            }, 1050);
          },
          true
        );
      }

      var progressFrame = null;
      var progressQueued = false;
      function scheduleProgressSync() {
        if (progressFrame) {
          progressQueued = true;
          return;
        }
        progressFrame = window.requestAnimationFrame(function() {
          progressFrame = null;
          bindPhotoInputs();
          completeOnPreviewReady();
          syncWaitCopy();
          if (typeof sectionRoot.__tpSyncPhotoAwaitingState === 'function') {
            getTeeFormNodes(document).forEach(sectionRoot.__tpSyncPhotoAwaitingState);
          }
          if (progressQueued) {
            progressQueued = false;
            scheduleProgressSync();
          }
        });
      }

      scheduleProgressSync();
      bindPopupSaveAdvance();

      if (typeof MutationObserver !== 'undefined') {
        function isInsidePhotoControl(node) {
          return !!(node && node.nodeType === 1 && node.closest && node.closest('.tee-photo'));
        }

        function containsPhotoControl(node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches('.tee-photo')) return true;
          return !!(node.querySelector && node.querySelector('.tee-photo'));
        }

        var progressObserver = new MutationObserver(function(records) {
          var shouldSync = records.some(function(record) {
            if (record.type === 'childList') {
              if (isInsidePhotoControl(record.target)) return true;
              return Array.prototype.some.call(record.addedNodes, containsPhotoControl) ||
                Array.prototype.some.call(record.removedNodes, containsPhotoControl);
            }
            if (record.type !== 'attributes' || record.attributeName !== 'class') return false;
            var currentClass = record.target && record.target.getAttribute
              ? record.target.getAttribute('class')
              : '';
            if (String(record.oldValue || '') === String(currentClass || '')) return false;
            return isInsidePhotoControl(record.target) || /(^|\s)tee-photo(\s|$)/.test(String(record.oldValue || ''));
          });
          if (shouldSync) scheduleProgressSync();
        });
        progressObserver.observe(sectionRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
          attributeOldValue: true
        });
      }
    }

    function initTeeinblueGiftWrapOption() {
      var sectionRoot = document.getElementById('MainProduct-' + TPMP.sectionId);
      if (!sectionRoot || sectionRoot.dataset.tpGiftWrapInit === '1') return;
      sectionRoot.dataset.tpGiftWrapInit = '1';

      var giftWrapVariantId = String(TPMP.giftWrap.variantId || '');
      if (!giftWrapVariantId) return;
      var giftWrapTitle = TPMP.giftWrap.titleEsc;
      var giftWrapPrice = TPMP.giftWrap.price;
      var giftWrapDescription = TPMP.giftWrap.descriptionEsc;
      var giftWrapImage = TPMP.giftWrap.image;

      if (!sectionRoot.dataset.tpGiftWrapChecked) {
        sectionRoot.dataset.tpGiftWrapChecked = '0';
      }

      function ensureGiftWrapControl(actionsNode, controlId) {
        if (!actionsNode) return null;
        var existingControl = actionsNode.querySelector('.tp-tee-gift-wrap');
        if (existingControl) return existingControl;

        var controlNode = document.createElement('div');
        controlNode.className = 'tee-checkbox-wrapper tp-tee-gift-wrap';
        controlNode.innerHTML = '' +
          '<div class="tp-gift-wrap-card__media">' +
            (giftWrapImage ? '<img src="' + giftWrapImage + '" alt="' + giftWrapTitle + '" loading="lazy" width="70" height="70">' : '') +
          '</div>' +
          '<div class="tp-gift-wrap-card__content">' +
            '<p class="tp-gift-wrap-card__title">' + giftWrapTitle + '</p>' +
            '<p class="tp-gift-wrap-card__price">' + giftWrapPrice + '</p>' +
            '<label class="tp-gift-wrap-card__toggle" for="' + controlId + '">' +
              '<input type="checkbox" id="' + controlId + '" data-tp-gift-wrap-toggle data-gift-variant-id="' + giftWrapVariantId + '">' +
              '<span>Dodaj opakowanie prezentowe</span>' +
            '</label>' +
          '</div>';

        var checkboxNode = controlNode.querySelector('input[type="checkbox"]');
        if (checkboxNode) {
          checkboxNode.checked = sectionRoot.dataset.tpGiftWrapChecked === '1';
        }

        var firstActionNode = actionsNode.querySelector('.tee-form-action');
        if (firstActionNode && firstActionNode.parentNode === actionsNode) {
          actionsNode.insertBefore(controlNode, firstActionNode);
        } else {
          actionsNode.insertBefore(controlNode, actionsNode.firstChild);
        }

        return controlNode;
      }

      function bindGiftWrapSync(checkboxNode) {
        if (!checkboxNode) return;
        function syncValue() {
          sectionRoot.dataset.tpGiftWrapChecked = checkboxNode.checked ? '1' : '0';
        }

        if (checkboxNode.dataset.tpGiftWrapBound !== '1') {
          checkboxNode.dataset.tpGiftWrapBound = '1';
          checkboxNode.addEventListener('change', syncValue);
        }
        syncValue();
      }

      function hydrateGiftWrapControls() {
        var formNodes = getTeeFormNodes(sectionRoot);
        if (!formNodes.length) return;

        formNodes.forEach(function(formNode, formIndex) {
          var actionsNodes = formNode.querySelectorAll('#teeFormActions, .tee-form-actions');
          if (!actionsNodes.length) {
            actionsNodes = sectionRoot.querySelectorAll('#teeFormActions, .tee-form-actions');
          }

          actionsNodes.forEach(function(actionsNode, actionsIndex) {
            var controlId = 'tp-tee-gift-wrap-' + TPMP.sectionId + '-' + formIndex + '-' + actionsIndex;
            var controlNode = ensureGiftWrapControl(actionsNode, controlId);
            if (!controlNode) return;

            var checkboxNode = controlNode.querySelector('input[type="checkbox"]');
            bindGiftWrapSync(checkboxNode);
          });
        });
      }

      hydrateGiftWrapControls();
      window.setTimeout(hydrateGiftWrapControls, 250);
      window.setTimeout(hydrateGiftWrapControls, 900);

      document.addEventListener('teeinblue:ready', hydrateGiftWrapControls);
      document.addEventListener('teeinblue:product-updated', hydrateGiftWrapControls);
      window.addEventListener('tapanda:tib-ready', hydrateGiftWrapControls);

      if (typeof MutationObserver !== 'undefined') {
        var observerRoot = getTeeFormNodes(sectionRoot)[0] || sectionRoot;
        var giftWrapObserver = new MutationObserver(function() {
          hydrateGiftWrapControls();
        });
        giftWrapObserver.observe(observerRoot, { childList: true, subtree: true });
      }
    }

    function initTeeinblueAtcSuccessNotice() {
      var sectionRoot = document.getElementById('MainProduct-' + TPMP.sectionId);
      if (!sectionRoot || sectionRoot.dataset.tpAtcSuccessNoticeInit === '1') return;
      sectionRoot.dataset.tpAtcSuccessNoticeInit = '1';

      function normalizeText(value) {
        return String(value || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function isAtcSuccessText(value) {
        if (!value) return false;
        return (
          value.indexOf('dodany do koszyka') !== -1 ||
          value.indexOf('ten przedmiot zostal dodany') !== -1 ||
          value.indexOf('added to cart') !== -1
        );
      }

      function decorateNoticeInActions(actionsNode) {
        if (!actionsNode) return;

        var cartLinks = actionsNode.querySelectorAll('a[href*="/cart"], a[href*="cart"]');
        cartLinks.forEach(function(linkNode) {
          var holderNode = linkNode;
          while (holderNode && holderNode !== actionsNode) {
            var nodeText = normalizeText(holderNode.textContent || '');
            if (isAtcSuccessText(nodeText)) {
              holderNode.classList.add('tp-tee-atc-success');
              linkNode.classList.add('tp-tee-atc-success__link');

              var iconNode = holderNode.querySelector('svg');
              if (iconNode) {
                iconNode.classList.add('tp-tee-atc-success__icon');
                holderNode.classList.remove('tp-tee-atc-success--no-icon');
              } else {
                holderNode.classList.add('tp-tee-atc-success--no-icon');
              }
              if (holderNode.dataset.tpPromoShown !== '1') {
                holderNode.dataset.tpPromoShown = '1';
                if (typeof window.tapandaShowCartPromotionPopup === 'function') {
                  var existingPopup = document.getElementById('tp-cart-promo-popup');
                  // Skip popup on Teeinblue pages — Teeinblue redirects to /cart natively
                  var isTeeProduct = !!(document.querySelector('#teeAtcButton, .tee-btn--atc, .tee-customize-main-form'));
                  if (!isTeeProduct && (!existingPopup || !existingPopup.classList.contains('is-visible'))) {
                    window.tapandaShowCartPromotionPopup();
                  }
                }
              }
              return;
            }
            holderNode = holderNode.parentElement;
          }
        });
      }

      function decorateAllNotices() {
        var actionsNodes = sectionRoot.querySelectorAll('#teeFormActions, .tee-form-actions');
        actionsNodes.forEach(function(actionsNode) {
          decorateNoticeInActions(actionsNode);
        });
      }

      decorateAllNotices();
      window.setTimeout(decorateAllNotices, 240);
      window.setTimeout(decorateAllNotices, 900);

      document.addEventListener('teeinblue:ready', decorateAllNotices);
      document.addEventListener('teeinblue:product-updated', decorateAllNotices);

      if (typeof MutationObserver !== 'undefined') {
        var observeRoot = getTeeFormNodes(sectionRoot)[0] || sectionRoot;
        var noticeObserver = new MutationObserver(function() {
          decorateAllNotices();
        });
        noticeObserver.observe(observeRoot, { childList: true, subtree: true });
      }
    }

      function initTapandaPdpReviewsAboveGallery() {
        var sectionId = TPMP.sectionId;

        function pinReviewsAboveGallery() {
          var sectionRoot = document.getElementById('MainProduct-' + sectionId);
          if (!sectionRoot) return;
          var mediaWrapper = sectionRoot.querySelector('.product__media-wrapper');
          if (!mediaWrapper) return;
          var reviews = mediaWrapper.querySelector('a.tp-pdp-reviews-desktop.tp-pdp-reviews-under-image');
          var gallery = mediaWrapper.querySelector('media-gallery');
          if (!reviews || !gallery) return;
          if (gallery.compareDocumentPosition(reviews) & Node.DOCUMENT_POSITION_FOLLOWING) {
            mediaWrapper.insertBefore(reviews, gallery);
          }
        }

        pinReviewsAboveGallery();
        window.setTimeout(pinReviewsAboveGallery, 80);
        window.setTimeout(pinReviewsAboveGallery, 320);
        window.setTimeout(pinReviewsAboveGallery, 900);
        window.setTimeout(pinReviewsAboveGallery, 2000);

        document.addEventListener('teeinblue:ready', pinReviewsAboveGallery);
        document.addEventListener('teeinblue:product-updated', function() {
          window.setTimeout(pinReviewsAboveGallery, 40);
        });

        if (typeof MutationObserver !== 'undefined') {
          var pinDebounce = null;
          function schedulePin() {
            if (pinDebounce) window.clearTimeout(pinDebounce);
            pinDebounce = window.setTimeout(function() {
              pinDebounce = null;
              pinReviewsAboveGallery();
            }, 50);
          }
          var sectionRoot = document.getElementById('MainProduct-' + sectionId);
          var mediaWrapper = sectionRoot && sectionRoot.querySelector('.product__media-wrapper');
          if (mediaWrapper) {
            var pinObserver = new MutationObserver(schedulePin);
            pinObserver.observe(mediaWrapper, { childList: true });
          }
        }
      }

    /* TeeInBlue renders the image-placement canvas at a fixed design size. Keep the
       dialog controls at their normal size and scale only that canvas. Scaling the
       whole .vm--modal also scales its positioning context and can clip the image. */
    function initTeeinblueModalFit() {
      if (TPMP.expectsTee === false) return;
      if (document.documentElement.dataset.tpModalFitInit === '1') return;
      document.documentElement.dataset.tpModalFitInit = '1';

      var MARGIN = 14;

      function viewportSize() {
        var vv = window.visualViewport;
        return {
          width: vv && vv.width ? vv.width : window.innerWidth,
          height: vv && vv.height ? vv.height : window.innerHeight
        };
      }

      function clearOne(m) {
        var cont = m.closest('.vm--container');
        var previewInner = m.querySelector('.tee-ip-preview-inner');
        m.classList.remove('tp-tee-image-placement-modal');
        m.classList.remove('tp-tee-gallery-modal');
        m.style.removeProperty('--tp-tee-modal-width');
        m.style.removeProperty('--tp-tee-modal-max-height');
        m.style.removeProperty('--tp-tee-preview-scale');
        m.style.removeProperty('--tp-tee-gallery-scale');
        m.style.removeProperty('--tp-tee-gallery-width');
        m.style.removeProperty('--tp-tee-gallery-height');
        if (previewInner) previewInner.style.removeProperty('--tp-tee-preview-scale');
        if (cont) {
          cont.classList.remove('tp-tee-image-placement-container');
          cont.classList.remove('tp-tee-gallery-container');
        }
        delete m.dataset.tpFit;
        delete m.dataset.tpModalW;
        delete m.dataset.tpGalleryW;
        delete m.dataset.tpGalleryH;
      }

      var previewResizeObserver = null;
      var observedPreviews = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

      function fitGallery(m, cont, gallerySlider) {
        var sliderWrap = gallerySlider.closest('.tee-dcontent-body-slider');
        if (!sliderWrap) return false;

        var naturalW = Math.max(
          parseFloat(m.dataset.tpGalleryW || '0'),
          parseFloat(gallerySlider.style.width || '0'),
          gallerySlider.offsetWidth || 0
        );
        var naturalH = Math.max(
          parseFloat(m.dataset.tpGalleryH || '0'),
          parseFloat(gallerySlider.style.height || '0'),
          gallerySlider.offsetHeight || 0
        );
        if (!naturalW || !naturalH) return false;

        m.dataset.tpGalleryW = String(naturalW);
        m.dataset.tpGalleryH = String(naturalH);

        var vp = viewportSize();
        var maxModalW = Math.max(1, vp.width - MARGIN * 2);
        var maxModalH = Math.max(1, vp.height - MARGIN * 2);
        var mobile = vp.width <= 749;
        var availableCanvasW = mobile ? Math.max(1, maxModalW - 24) : naturalW;
        var availableCanvasH = Math.max(1, maxModalH - (mobile ? 118 : 74));
        var scale = Math.min(1, availableCanvasW / naturalW, availableCanvasH / naturalH);
        var roundedScale = Math.max(0.1, Math.round(scale * 1000) / 1000);
        var renderedW = Math.max(1, Math.round(naturalW * roundedScale));
        var renderedH = Math.max(1, Math.round(naturalH * roundedScale));
        var naturalModalW = Math.max(
          parseFloat(m.dataset.tpModalW || '0'),
          parseFloat(m.style.width || '0'),
          m.offsetWidth || 0,
          naturalW
        );

        m.dataset.tpModalW = String(naturalModalW);
        cont.classList.add('tp-tee-gallery-container');
        m.classList.add('tp-tee-gallery-modal');
        m.style.setProperty('--tp-tee-modal-width', Math.min(naturalModalW, maxModalW) + 'px');
        m.style.setProperty('--tp-tee-modal-max-height', maxModalH + 'px');
        m.style.setProperty('--tp-tee-gallery-scale', String(roundedScale));
        m.style.setProperty('--tp-tee-gallery-width', renderedW + 'px');
        m.style.setProperty('--tp-tee-gallery-height', renderedH + 'px');
        m.dataset.tpFit = 'gallery';
        return true;
      }

      function fitOne(m) {
        var placementBody = m.querySelector('.tee-image-placement-body');
        var preview = m.querySelector('.tee-ip-preview');
        var previewInner = m.querySelector('.tee-ip-preview-inner');
        var cont = m.closest('.vm--container');
        var gallerySlider = m.querySelector('.tee-dcontent-body-slider .tee-slider');

        if (gallerySlider && cont && fitGallery(m, cont, gallerySlider)) return;

        /* Other vue-js-modal dialogs are already responsive in the app. */
        if (!placementBody || !preview || !previewInner || !cont) {
          if (m.dataset.tpFit) clearOne(m);
          return;
        }

        var previewW = previewInner.offsetWidth || parseFloat(previewInner.style.width || '0');
        var previewH = previewInner.offsetHeight || parseFloat(previewInner.style.height || '0');
        var modalNaturalW = Math.max(
          parseFloat(m.dataset.tpModalW || '0'),
          parseFloat(m.style.width || '0'),
          m.offsetWidth || 0
        );
        if (!previewW || !previewH || !modalNaturalW) return;

        m.dataset.tpModalW = String(modalNaturalW);

        if (previewResizeObserver && (!observedPreviews || !observedPreviews.has(previewInner))) {
          previewResizeObserver.observe(previewInner);
          if (observedPreviews) observedPreviews.add(previewInner);
        }

        var vp = viewportSize();
        var maxModalW = Math.max(1, vp.width - MARGIN * 2);
        var maxModalH = Math.max(1, vp.height - MARGIN * 2);
        var previewRect = previewInner.getBoundingClientRect();
        /* Horizontal chrome is the actual dialog padding, not the difference
           between TeeInBlue's inline modal width and its responsive canvas. */
        var chromeW = Math.max(0, (m.offsetWidth || 0) - (placementBody.offsetWidth || 0));
        var chromeH = Math.max(0, (m.offsetHeight || 0) - previewRect.height);
        var availablePreviewW = Math.max(1, maxModalW - chromeW);
        var availablePreviewH = Math.max(1, maxModalH - chromeH);
        var scale = Math.min(
          1,
          availablePreviewW / previewW,
          availablePreviewH / previewH
        );
        var roundedScale = Math.max(0.1, Math.round(scale * 1000) / 1000);
        var fittedModalW = Math.min(modalNaturalW, maxModalW);

        cont.classList.add('tp-tee-image-placement-container');
        m.classList.add('tp-tee-image-placement-modal');
        m.style.setProperty('--tp-tee-modal-width', fittedModalW + 'px');
        m.style.setProperty('--tp-tee-modal-max-height', maxModalH + 'px');
        m.style.setProperty('--tp-tee-preview-scale', String(roundedScale));
        previewInner.style.setProperty('--tp-tee-preview-scale', String(roundedScale));
        m.dataset.tpFit = 'placement';
      }

      function fitAll() {
        var modals = document.querySelectorAll('.vm--modal');
        var retry = false;
        for (var i = 0; i < modals.length; i++) {
          var m = modals[i];
          /* modal wstawiony, ale jeszcze nie wymierzony -> sprobuj ponownie za chwile */
          if (!m.querySelector('.tee-ip-preview-inner, .tee-dcontent-body-slider .tee-slider') && !m.offsetWidth) retry = true;
          fitOne(m);
        }
        if (retry) window.setTimeout(schedule, 80);
      }

      var pending = false;
      function schedule() {
        if (pending) return;
        pending = true;
        /* setTimeout (nie rAF) — dziala takze gdy karta jest w tle/niewidoczna */
        window.setTimeout(function() { pending = false; fitAll(); }, 16);
      }

      if (typeof ResizeObserver !== 'undefined') {
        previewResizeObserver = new ResizeObserver(schedule);
      }

      var watchRoot = document.body;
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(schedule).observe(watchRoot, { childList: true, subtree: true });
      }
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('orientationchange', schedule, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', schedule, { passive: true });
      }
      schedule();
    }

    function initMobileProductMediaSticky() {
      var sectionRoot = document.getElementById('MainProduct-' + TPMP.sectionId);
      if (!sectionRoot || !sectionRoot.classList.contains('tp-has-personalizer')) return;

      var mediaWrapper = sectionRoot.querySelector('.product__media-wrapper');
      if (!mediaWrapper || mediaWrapper.dataset.tpMobileMediaStickyInit === '1') return;
      mediaWrapper.dataset.tpMobileMediaStickyInit = '1';

      var mobileQuery = window.matchMedia('(max-width: 749px)');
      var rafId = null;
      var stickyStart = 0;
      var mediaWidth = 0;
      var minScale = 0.62;
      var shrinkRange = 180;

      function currentImageBox() {
        return sectionRoot.querySelector('.tee-popup-zoom')
          || sectionRoot.querySelector('.tee-mockup-zoomable')
          || sectionRoot.querySelector('.product__media-item.is-active');
      }

      function getScrollTop() {
        return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      }

      function measure() {
        var node = mediaWrapper;
        var pageTop = 0;
        while (node) {
          pageTop += node.offsetTop || 0;
          node = node.offsetParent;
        }
        stickyStart = pageTop;
        mediaWidth = mediaWrapper.offsetWidth || 0;
      }

      function resetDesktopState() {
        mediaWrapper.classList.remove('is-scrolled-sticky');
        mediaWrapper.classList.remove('is-media-scaled');
        mediaWrapper.style.removeProperty('--tp-pdp-scale');
      }

      function render() {
        rafId = null;
        if (!mobileQuery.matches) {
          resetDesktopState();
          /* 25.07: etykieta „-30%" siedzi teraz w kontenerze grafiki (.tee-gallery)
             i pozycjonuje ją place() w sections/main-product.liquid. Ten blok
             liczył ją względem .product__media-wrapper (955px zamiast 665px),
             nadpisywał pozycję przy KAZDYM przewinięciu i dokładał rotate(-6deg)
             — przez to odjeżdżała od zdjęcia i wracał obrót starej naklejki. */
          return;
        }

        var scrollTop = getScrollTop();
        var progress = Math.max(0, Math.min(1, scrollTop / shrinkRange));
        var scale = 1 - progress * (1 - minScale);
        mediaWrapper.style.setProperty('--tp-pdp-scale', scale.toFixed(4));
        mediaWrapper.classList.toggle('is-media-scaled', progress > 0);
        mediaWrapper.classList.toggle('is-scrolled-sticky', scrollTop >= Math.max(0, stickyStart - 1));

        var badge = mediaWrapper.querySelector('.tp-pdp-multibuy');
        if (badge && mediaWidth > 0) {
          badge.style.left = Math.round((mediaWidth / 2) * (1 - scale) + 12) + 'px';
          badge.style.top = '12px';
          badge.style.transformOrigin = 'top left';
          badge.style.removeProperty('transform');   /* bez obrotu — etykieta ma styl przycisku */
        }
      }

      function schedule() {
        if (rafId !== null) return;
        rafId = window.requestAnimationFrame(render);
      }

      function measureAndSchedule() {
        measure();
        schedule();
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', measureAndSchedule, { passive: true });
      window.addEventListener('orientationchange', function() {
        window.setTimeout(measureAndSchedule, 120);
      }, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('scroll', schedule, { passive: true });
      }
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', measureAndSchedule);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(measureAndSchedule);
      }

      measureAndSchedule();
      window.setTimeout(measureAndSchedule, 400);
      window.setTimeout(measureAndSchedule, 1200);
      window.setTimeout(measureAndSchedule, 2500);
    }

    /* Krok „Chcesz dodać własne zmiany?" — ukryty domyślnie, wysuwa się po 3. wgraniu zdjęcia.
       Działa tylko tam, gdzie ten krok istnieje (wykrywany po tytule). Krok jest opcjonalny
       (domyślnie „Nie") i nie blokuje progresji — patrz isStepComplete/isCustomChangesStep. */
    function initTeeinblueCustomChangesReveal() {
      var sectionRoot = document.getElementById('MainProduct-' + TPMP.sectionId);
      if (!sectionRoot || sectionRoot.dataset.tpCcRevealInit === '1') return;
      sectionRoot.dataset.tpCcRevealInit = '1';

      var REVEAL_AFTER = 3;
      var uploadCount = 0;
      var revealed = false;

      function ccMatch(stepNode) {
        var head = stepNode.querySelector('.tee-field__heading, .tee-field__header, .tee-option__title');
        var t = ((head ? head.textContent : '') || '').toLowerCase();
        return t.indexOf('własne zmiany') !== -1 || t.indexOf('wlasne zmiany') !== -1;
      }
      function ccSteps() {
        return Array.prototype.filter.call(sectionRoot.querySelectorAll('.tee-field, .tee-option'), ccMatch);
      }
      function applyState() {
        ccSteps().forEach(function(step) {
          step.dataset.tpCcStep = '1';
          if (!step.classList.contains('tp-cc-step')) step.classList.add('tp-cc-step');
          if (revealed) {
            if (step.dataset.tpCcHidden === '1') {
              step.style.removeProperty('display');
              delete step.dataset.tpCcHidden;
              step.classList.add('tp-cc-revealed');
            }
          } else if (step.dataset.tpCcHidden !== '1') {
            step.style.setProperty('display', 'none', 'important');
            step.dataset.tpCcHidden = '1';
          }
        });
      }
      function reveal() {
        if (revealed) return;
        revealed = true;
        applyState();
        var first = ccSteps()[0];
        if (first) { try { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
      }

      /* Licznik wgrań zdjęcia (delegacja — przetrwa re-render inputa przez TeeInBlue). */
      sectionRoot.addEventListener('change', function(e) {
        var t = e.target;
        if (!t || t.type !== 'file') return;
        if (!t.closest || !t.closest('.tee-photo')) return;
        if (!t.files || !t.files.length) return;
        uploadCount += 1;
        if (uploadCount >= REVEAL_AFTER) reveal();
      }, true);

      var ccTimer = null;
      function ccSchedule() {
        if (ccTimer) return;
        ccTimer = window.setTimeout(function() { ccTimer = null; applyState(); }, 60);
      }

      applyState();
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(function(records) {
          if (mutationBatchTouchesTeeinblue(records)) ccSchedule();
        }).observe(sectionRoot, { childList: true, subtree: true });
      }
    }

      function boot() {
      initTeeinblueVariantBridge();
      initTeeinblueGuidedSteps();
      initTeeinblueUploadProgress();
      initTeeinblueGiftWrapOption();
      initTeeinblueAtcSuccessNotice();
      initTeeinblueModalFit();
      initTeeinblueCustomChangesReveal();
      initTapandaPdpReviewsAboveGallery();
      initMobileProductMediaSticky();

      initNotifyToggle();
      initInlineDiscount();
      if (!initZoomPlugins()) {
        setTimeout(initZoomPlugins, 600);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

/* ── Feedback zablokowanych kroków personalizacji (audyt/Clarity 2026-07: dead-clicki
   na krokach nieaktywnych — klik po cichu nic nie robił, klienci uznawali stronę za
   zepsutą). Kliknięcie w nieaktywny krok pokazuje podpowiedź i przewija do aktywnego. ── */
(function () {
  var lastHighlightAt = 0;

  function injectStyles() {
    if (document.getElementById('tp-step-feedback-css')) return;
    var css = document.createElement('style');
    css.id = 'tp-step-feedback-css';
    css.textContent =
      '.tp-step-pulse{position:relative;z-index:1;outline:3px solid rgba(186,122,75,.72);outline-offset:3px;animation:tpStepPulse .95s ease 2}' +
      '@keyframes tpStepPulse{0%,100%{box-shadow:0 0 0 0 rgba(186,122,75,0)}45%{box-shadow:0 0 0 8px rgba(186,122,75,.30),0 12px 30px rgba(104,64,35,.16)}}' +
      '@media(prefers-reduced-motion:reduce){.tp-step-pulse{animation:none;box-shadow:0 0 0 7px rgba(186,122,75,.22)}}';
    document.head.appendChild(css);
  }

  function showFeedback(formNode) {
    var now = Date.now();
    if (now - lastHighlightAt < 800) return;
    lastHighlightAt = now;

    var activeStep = formNode.querySelector('.tp-guided-step.is-active-step');
    if (activeStep) {
      try { activeStep.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { activeStep.scrollIntoView(); }
      activeStep.classList.remove('tp-step-pulse');
      void activeStep.offsetWidth;
      activeStep.classList.add('tp-step-pulse');
      if (activeStep.__tpStepPulseTimer) window.clearTimeout(activeStep.__tpStepPulseTimer);
      activeStep.__tpStepPulseTimer = window.setTimeout(function () {
        activeStep.classList.remove('tp-step-pulse');
        activeStep.__tpStepPulseTimer = null;
      }, 2200);
    }
  }

  /* Zablokowany = ani aktywny, ani ukończony. Kroki UKOŃCZONE (wcześniejsze —
     kolor ramki, rozmiar) muszą być swobodnie klikalne: klient może zmienić
     wybór nawet gdy dalsze kroki (zdjęcie, teksty) czekają. */
  function isInteractiveStep(step) {
    return step.classList.contains('is-active-step') ||
      step.classList.contains('is-complete') ||
      step.classList.contains('is-expanded');
  }

  function findLockedStepAtPoint(x, y) {
    if (!document.elementsFromPoint) return null;
    var stack = document.elementsFromPoint(x, y);
    for (var i = 0; i < stack.length; i += 1) {
      var node = stack[i];
      if (!node || !node.classList) continue;
      var step = node.classList.contains('tp-guided-step') ? node : (node.closest ? node.closest('.tp-guided-step') : null);
      if (step && !isInteractiveStep(step)) return step;
      if (step) return null;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    if (typeof event.clientX !== 'number') return;
    var direct = event.target && event.target.closest ? event.target.closest('.tp-guided-step') : null;
    var step = direct || findLockedStepAtPoint(event.clientX, event.clientY);
    if (!step || isInteractiveStep(step)) return;
    var formNode = step.closest ? step.closest('form, .tee-customize-main-form') : null;
    if (!formNode) return;
    injectStyles();
    showFeedback(formNode, step);
  }, true);
})();

/* ── Watchdog konfiguratora Teeinblue (audyt N-4, wersja uzgodniona z właścicielem:
   BEZ zapasowego przycisku kupna — projekt klienta powstaje tylko w konfiguratorze.
   Gdy skrypt Teeinblue nie wstanie w rozsądnym czasie, pokazujemy komunikat z
   przyciskiem ponownego załadowania strony zamiast martwej karty bez wyjaśnienia. ── */
(function () {
  var cfg = window.tapandaMainProductCfg || {};
  if (cfg.expectsTee === false) return;

  var CHECK_AFTER_MS = 9000;
  var NOTICE_ID = 'tp-tee-watchdog-notice';

  function teePresent() {
    return !!document.querySelector(
      '#teeAtcButton, .tee-form-actions, .tee-customize-main-form, .tee-btn--atc, [data-teeinblue] form'
    );
  }

  function showNotice() {
    if (document.getElementById(NOTICE_ID)) return;
    var host =
      document.querySelector('.product__info-container') ||
      document.querySelector('.main-product-template') ||
      document.body;
    var box = document.createElement('div');
    box.id = NOTICE_ID;
    box.setAttribute('role', 'alert');
    box.style.cssText = 'margin:1.2rem 0;padding:1.3rem 1.4rem;border:1px solid rgba(180,35,24,.4);border-radius:1.2rem;background:rgba(180,35,24,.06);color:#3e3d3d;font-size:1.35rem;line-height:1.5;';
    box.innerHTML =
      '<strong style="display:block;margin-bottom:.4rem;">Konfigurator personalizacji nie załadował się.</strong>' +
      'Zwykle pomaga ponowne załadowanie strony. Jeśli problem wraca, sprawdź połączenie z internetem lub napisz do nas: kontakt@tapanda.pl.' +
      '<button type="button" style="display:block;margin-top:.9rem;padding:.7rem 1.4rem;border-radius:.9rem;border:1px solid #ba7a4b;background:#ba7a4b;color:#fff;font-weight:600;cursor:pointer;" ' +
      'onclick="window.location.reload()">Załaduj ponownie konfigurator</button>';
    host.insertBefore(box, host.firstChild);
  }

  function armWatchdog() {
    window.setTimeout(function () {
      if (teePresent()) return;
      window.setTimeout(function () {
        if (!teePresent()) showNotice();
      }, 3000);
    }, CHECK_AFTER_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armWatchdog, { once: true });
  } else {
    armWatchdog();
  }
})();
